<template>
  <div class="detail" v-loading.fullscreen.lock="loading || materialSaving || planRemarkSaving">
    <!-- 顶部 -->
    <detailHeader />
    <!-- 订单 -->
    <div v-if="!isProductNameEditor">
      <!-- 订单头部 -->
      <orderHeader :detail="detail" v-if="show" />
      <!-- 订单详情 -->
      <div class="orderDetail">
        <div class="tabs">
          <el-tabs v-model="activeName" @tab-click="handleClick" type="card">
            <!-- 当前订单信息 -->
            <el-tab-pane :label="$t('message.currentOrderInformation')" name=""></el-tab-pane>
            <!-- 已删除 -->
            <el-tab-pane :label="$t('message.deleted') + detail.order_detail_discard.length"
              name="delete"></el-tab-pane>
          </el-tabs>
          <div class="tabsActions">
            <!-- 操作配置与表头配置使用相同的勾选、保存方式。 -->
            <el-button v-if="activeName != 'delete'" type="primary" size="small"
              @click="operationSettingsVisible = true">
              {{ $t('message.customOperations') }}
            </el-button>
            <!-- 自定义表头 -->
            <el-button v-if="activeName != 'delete'" type="primary" size="small"
              @click="columnSettingsVisible = true">
              {{ $t('message.customColumns') }}
            </el-button>
            <!-- 追加商品 -->
            <el-button type="success" size="small" @click="$refs.appendProduct.setData()"
              v-if="[20, 21, 22].includes(status) && isAuth(668)">
              {{ $t("message.appendProduct") }}
            </el-button>
            <el-button v-if="activeName != 'delete' && materialRows.length" size="small" @click="toggleAllMaterials">
              {{ allMaterialsExpanded ? $t('message.materialCollapseAll') : $t('message.materialExpandAll') }}
            </el-button>
          </div>
        </div>
        <!-- 订单列表 -->
        <div class="table" v-if="activeName != 'delete'">
          <!-- 列表头部 -->
          <ol>
            <!-- 番号 -->
            <li v-if="isColumnVisible('sorting')" class="flex05"> {{ $t("message.mash") }}</li>
            <!-- 选择 -->
            <li class="flex05">
              {{ $t("message.choose") }}
            </li>
            <!-- 店铺信息 -->
            <li v-if="isColumnVisible('shopInformation')" class="flex15 shop" style="cursor: pointer;"
              @dblclick="reCompletion">
              {{ $t("message.storeInformation") }}
            </li>
            <!-- 照片 -->
            <li v-if="isColumnVisible('picture')" class="flex15">
              {{ $t("message.pic") }}
            </li>
            <!-- 客户下单商品属性 -->
            <li class="flex2 important" v-if="status != 21 && isColumnVisible('customerProductAttributes')">
              {{ $t("message.attributesOfGoodsPlacedByCustomers") }}
            </li>
            <!-- 业务编辑属性 -->
            <li v-if="isColumnVisible('businessEditAttributes')" class="flex2 important">
              {{ $t("message.businessEditAttributes") }}
            </li>
            <!-- 下单数据 -->
            <li v-if="isColumnVisible('orderData')">
              {{ $t("message.orderData") }}
            </li>
            <!-- 报价在库数 -->
            <li v-if="status == 22 && isColumnVisible('quoteInLibraryNumber')">
              {{ $t("message.quoteInLibraryNumber") }}
            </li>
            <!-- 报价单价 -->
            <li v-if="status == 22 && isColumnVisible('quotationUnitPrice')">
              {{ $t("message.quotationUnitPrice") }}
            </li>
            <!-- 报价国内运费 -->
            <li v-if="status == 22 && isColumnVisible('quoteDomesticShipping')">
              {{ $t("message.quoteDomesticShipping") }}
            </li>

            <!-- 报价-->
            <li v-if="status > 22 && isColumnVisible('quotedPrice')">
              {{ $t("message.quotedPrice") }}
            </li>
            <!-- 报价国内运费-->
            <li v-if="status > 22 && isColumnVisible('quoteDomesticShipping')">
              {{ $t("message.quoteDomesticShipping") }}
            </li>
            <!-- 小计 -->
            <li v-if="status > 22 && isColumnVisible('subtotal')">
              {{ $t("message.subtotal") }}
            </li>
            <!-- 小计 -->
            <li v-if="status == 20 && isColumnVisible('subtotal')">
              {{ $t("message.subtotal") }}
            </li>
            <!-- 附加服务 -->
            <li class="flex2 important" v-if="status != 21 && isColumnVisible('additionalServices')">
              {{ $t("message.additionalServices") }}
            </li>
            <!-- 原价计算option 定制 -->
            <li class="flex2 important"
              v-if="status == 22 && isCustomMade && isColumnVisible('originalPriceCalculationOption')">
              {{ $t("message.originalPriceCalculationOption") }}
            </li>
            <!-- 标签编号 -->
            <li class="flex2" v-if="status != 21 && isColumnVisible('tagNumber')">
              {{ $t("message.tagNumber") }}
            </li>
            <!-- 客户商品备注 -->
            <li class="flex2 important" v-if="status != 21 && isColumnVisible('customerProductRemarks')">
              {{ $t("message.customerProductRemarks") }}
            </li>
            <!-- 业务回复 -->
            <li class="flex2 important" v-if="status >= 22 && isColumnVisible('businessReply')">
              {{ $t("message.businessReply") }}(给客户)
            </li>
            <!-- 商品规格cm/g -->
            <li v-if="status > 22 && isColumnVisible('productSpecifications')" class="flex15">
              {{ $t("message.productSpecifications") }}cm/kg
            </li>
            <!-- 业务翻译 -->
            <li v-if="isColumnVisible('businessTranslation')" class="flex2 important">
              {{ $t("message.businessTranslation") }}
            </li>
            <!-- 报价在库数 (调查在库数) -->
            <li v-if="status == 21 && isColumnVisible('quoteInLibraryNumber')">
              {{ $t("message.quoteInLibraryNumber") }}
            </li>
            <!--报价单价 (调查单价) -->
            <li v-if="status == 21 && isColumnVisible('quotationUnitPrice')">
              {{ $t("message.quotationUnitPrice") }}
            </li>
            <!-- 报价国内运费 (调查运费) -->
            <li v-if="status == 21 && isColumnVisible('quoteDomesticShipping')">
              {{ $t("message.quoteDomesticShipping") }}
            </li>
            <!-- 小计 -->
            <li v-if="status == 21 && isColumnVisible('subtotal')">
              {{ $t("message.subtotal") }}
            </li>
            <!-- 参考单价 -->
            <li v-if="status == 21 && isColumnVisible('referenceUnitPrice')">
              {{ $t("message.referenceUnitPrice") }}
            </li>
            <!-- 实际采购价 -->
            <li v-if="status == 21 && isColumnVisible('confirmPurchasePrice')">
              <el-button type="text" @click="orderCreatePreview"> {{ $t("message.confirmPurchasePrice") }}</el-button>
            </li>
            <!-- 确认国内运费 -->
            <li v-if="status == 21 && isColumnVisible('confirmDomesticShipping')">
              {{ $t("message.confirmDomesticShipping") }}
            </li>
            <!-- 单个商品尺寸.cm -->
            <li v-if="(status == 21 || status == 22) && isColumnVisible('singleItemSize')"
              @dblclick="goodsWeightSizeHistory" style="cursor: pointer;">
              {{ $t("message.singleItemSize") }}
            </li>
            <!-- 单个重量.g -->
            <li v-if="(status == 21 || status == 22) && isColumnVisible('individualWeight')">
              {{ $t("message.individualWeight") }}
            </li>

            <!-- 采购备注 -->
            <li class="flex2 important"
              v-if="(status >= 21 || status == -2) && isColumnVisible('purchasingNotes')">
              {{ $t("message.purchasingNotes") }}
            </li>
            <!-- 替换链接-->
            <li v-if="(status == 21 || status == 22) && isColumnVisible('replaceTheLink')">
              {{ $t("message.replaceTheLink") }}
            </li>
            <!-- 跟单备注-->
            <li v-if="isColumnVisible('documentaryRemarks')">
              {{ $t("message.documentaryRemarks") }}
            </li>
          </ol>
          <!-- list -->
          <div v-for="(item, index) in detail.order_detail" :key="item.id || index" class="goodsGroup">
            <ul
              :class="{ editItem: item.is_client_modify == 1, addItem: item.client_modify_field.indexOf('all') != -1 }">
            <li v-if="isColumnVisible('sorting')" class="flex05 noCell">
              <div v-if="isMaterial(item)" class="materialMarkTip">
                <MaterialMarkTip :material-id="item.material_id || (item.material && item.material.id)"
                  :user-id="detail.user_id" :detail="item.material || {}" />
              </div>
              <div class="sorting">
                <!-- 是否加入商品管理 -->
                <div class="claim" v-if="item.client_product_mark">
                  <router-link
                    :to="{ name: 'productManagementV2', query: { tab: 'all', user_id: detail.user_id, client_sku_code: item.client_sku_code } }"
                    target="_blank">
                    <i :class="item.client_product_mark == 1 ? 'el-icon-shopping-bag-1' : 'el-icon-s-claim'"></i>
                  </router-link>
                </div>
                {{ item.sorting }}
                <!-- 已存在询盘数据时显示入口，点击查看该番最新 20 条询盘记录。 -->
                <el-tag v-if="status == 21 && item.goods_inquiry" class="goods-inquiry-tag" size="mini"
                  type="warning" effect="dark" @click.stop="openGoodsInquiryRecords(item)">
                  {{ $t('message.productInquiry') }}
                </el-tag>
                <div class="contraband" v-if="item.forbid_goods != false && item.forbid_goods != null">
                  <el-popover placement="right" width="200" trigger="hover">
                    <div> {{ item.forbid_goods.type_name }}</div>
                    <img src="@/assets/img/contraband1.png" alt="" slot="reference"
                      v-if="item.forbid_goods.status == 3">
                    <img src="@/assets/img/contraband.png" alt="" slot="reference" v-else>
                  </el-popover>
                </div>
              </div>
              <div class="isZhu" v-if="item.isZhu" @click="$refs.kitAssembly.getDataList(item.group)">
                组套-主
              </div>
              <div class="isZhu isTong" v-if="item.set_detail_id != '' && item.set_detail_id != -1"
                @click="$refs.kitAssembly.getDataList(item.group)">
                组套-{{ getSorting(item.set_detail_id) }}番-同捆
              </div>
              <!-- 无辅料时仍可展开查看当前工种可见的下单要求。 -->
              <el-button class="materialToggle" type="text" size="mini"
                @click.stop="toggleMaterial(item)">
                {{ item.materialExpanded ? $t("message.collapse") : $t("message.expand") }}
                <i :class="item.materialExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
              </el-button>
            </li>
            <!-- 选择 -->
            <li class="flex05">
              <label>
                <el-popover placement="right" title="合计数量" width="200" trigger="focus">
                  <statistics :checkedList="checkedList" :status="status" />
                  <el-checkbox v-model="item.checked" @change="theRadio" slot="reference"></el-checkbox>
                </el-popover>
              </label>
            </li>
            <!-- 店铺信息 -->
            <li v-if="isColumnVisible('shopInformation')" class="flex15 shop">
              <div class="template">
                <div class="shopName" :title="item.shop_name">{{ item.shop_name }}</div>
                <p style="color: #15ad3c;margin: 5px 0; ">{{ item.from_platform }} ({{ (item.service_rate *
                  100).toFixed(1) }}%)</p>
                <div class="shopName goodsId" :title="item.goods_id" @click="item.goods_id && copy(item.goods_id)">
                  {{ item.goods_id || '-' }}
                </div>
                <!-- 供应商订单标签 -->
                <p v-if="item.is_supplier_goods == 1">
                  <el-tag size="mini" type="primary" class="primary" effect="dark">供应商订单</el-tag>
                </p>
                <!-- 供应商报价 -->
                <p v-if="item.is_supplier_goods == 1"> <el-tag size="mini"
                    :type="item.is_supplier_quoted == 1 ? 'success' : 'primary'" effect="dark">{{
                      item.is_supplier_quoted == 1 ? '供应商已报价' : '待供应商报价' }}</el-tag></p>
              </div>
            </li>
            <!-- 照片 -->
            <li v-if="isColumnVisible('picture')" class="flex15">
              <div>
                <!-- tort_detect 不为空，且双路风险任一明确为高风险时显示入口 -->
                <el-tag class="tort-detect-tag" size="mini" effect="dark"
                  :type="getTortRiskType(item.tort_detect)"
                  v-if="isShowTortRisk(item.tort_detect)" @click.stop="openTortDetect(item)">
                  侵权风险
                </el-tag>
                <div class="pic">
                  <el-popover placement="right" width="300" trigger="hover">
                    <img :src="item.pic" alt="" style="width: 300px; " />
                    <a :href="item.link" slot="reference" target="_blank">
                      <el-image :src="item.pic" style="width: 60px; height: 60px; border-radius: 4px">
                        <div slot="placeholder" class="image-slot">
                          加载中<span class="dot">...</span>
                        </div>
                      </el-image>
                    </a>
                  </el-popover>
                  <div class="edit" v-if="status < 30 && status != 21">
                    <el-upload class="avatar-uploader" :action="baseURL + '/api/common/uploadFile'"
                      :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
                      <i class="el-icon-edit-outline" @click="i = index"></i>
                    </el-upload>
                  </div>
                  <!-- 采购用 -->
                  <div class="edit" v-if="status == 21">
                    <i class="el-icon-shopping-bag-2" @click="uploadImagePic(item.pic)"></i>
                  </div>
                </div>

                <el-input size="mini" placeholder="管理番号" v-model="item.for_sn" style="padding: 0;"
                  @blur="batchUpdateOrderDetailForSn(item)" v-if="isAuth(579)"></el-input>
                <p v-else>{{ item.for_sn }}</p>
              </div>
            </li>
            <!-- 客户下单商品属性 -->
            <li class="flex2 important" v-if="status != 21 && isColumnVisible('customerProductAttributes')">
              <div class="attribute" :class="{ orderEdit: item.client_modify_field.indexOf('detail') != -1 }">
                <el-tooltip placement="bottom" style="height:100px">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail" :key="itemIndex">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
            </li>
            <!-- 业务编辑属性 -->
            <li v-if="isColumnVisible('businessEditAttributes')" class="flex2 important">
              <div class="attribute">
                <el-tooltip placement="bottom" style="height:100px">
                  <div slot="content">
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      style="margin-bottom: 5px">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                  <div>
                    <div class="row" v-for="(itemDetail, itemIndex) in item.detail_y" :key="itemIndex"
                      @click="copy(itemDetail.value)">
                      {{ itemDetail.key }}：{{ itemDetail.value }}
                    </div>
                  </div>
                </el-tooltip>
              </div>
              <div class="edit" v-if="status < 30 && status != 21">
                <i class="el-icon-edit-outline" @click="attributeEdit(item, index)"></i>
              </div>
            </li>
            <!-- 下单数据 -->
            <li v-if="isColumnVisible('orderData')">
              <div class="template">
                <!-- 数量 -->
                <p :class="{ orderEdit: item.client_modify_field.indexOf('num') != -1 }">{{ $t("message.number") }}:
                  {{ item.num }}
                </p>
                <!-- 单价 -->
                <p>{{ $t("message.price") }}:{{ item.price }}
                </p>
              </div>
            </li>
            <!-- 报价在库数 -->
            <li v-if="status == 22 && isColumnVisible('quoteInLibraryNumber')">
              <div class="template">
                <p :class="{ hint: item.num != item.confirm_num }">{{ $t("message.inStock") }}:{{ item.confirm_num }}
                </p>
                <el-input v-model="item.offer_num" size="mini" onfocus="this.select()"
                  @input="computationalSost('offer_num', item.offer_num, item.checked, index)" v-if="isAuth(517)"
                  :disabled="item.is_supplier_goods == 1">
                </el-input>
                <span v-else>
                  {{ item.offer_num }}
                </span>
                <!-- 大货数量 定制 -->
                <div class="isCustomMade" v-if="isCustomMade">
                  <el-input v-model="item.bulk_quantity" size="mini" onfocus="this.select()"
                    @input="computationalSost('bulk_quantity', item.bulk_quantity, item.checked, index)"
                    :placeholder="$t('message.largeGoodsNumber')" :title="$t('message.largeGoodsNumber')"></el-input>
                </div>
              </div>
            </li>
            <!-- 报价单价 -->
            <li v-if="status == 22 && isColumnVisible('quotationUnitPrice')">
              <div class="template">
                <p :class="{ hint: item.price != item.confirm_price }">{{ $t("message.price") }}:
                  {{ item.confirm_price
                  }}</p>

                <el-input v-model="item.offer_price" size="mini" onfocus="this.select()"
                  @input="computationalSost('offer_price', item.offer_price, item.checked, index)" v-if="isAuth(517)"
                  :disabled="item.is_supplier_goods == 1"></el-input>

                <span v-else>
                  {{ item.offer_price }}
                </span>
                <!-- 大货报价 定制 -->
                <div class="isCustomMade" v-if="isCustomMade">
                  <el-input v-model="item.bulk_price" size="mini" onfocus="this.select()"
                    @input="computationalSost('bulk_price', item.bulk_price, item.checked, index)"
                    :placeholder="$t('message.bulkQuotation')" :title="$t('message.bulkQuotation')"></el-input>
                </div>
              </div>
            </li>
            <!-- 报价国内运费 -->
            <li v-if="status == 22 && isColumnVisible('quoteDomesticShipping')">
              <div class="template">
                <p>{{ $t("message.freight") }}:{{ item.confirm_freight }}</p>
                <el-input v-model="item.offer_freight" size="mini" onfocus="this.select()"
                  @input="computationalSost('offer_freight', item.offer_freight, item.checked, index)"
                  disabled></el-input>
                <!--大货运费 定制 -->
                <div class="isCustomMade" v-if="isCustomMade">
                  <el-input v-model="item.bulk_freight" size="mini" onfocus="this.select()"
                    @input="computationalSost('bulk_freight', item.bulk_freight, item.checked, index)"
                    :placeholder="$t('message.bulkShippingCost')" :title="$t('message.bulkShippingCost')"></el-input>
                </div>
              </div>

            </li>

            <!-- 报价-->
            <li v-if="status > 22 && isColumnVisible('quotedPrice')">
              <div class="template">
                <p>{{ $t("message.inStock") }}:{{ item.offer_num_bak }}</p>
                <p>{{ $t("message.price") }}:{{ item.offer_price_bak }}</p>
              </div>
            </li>
            <!-- 报价国内运费-->
            <li v-if="status > 22 && isColumnVisible('quoteDomesticShipping')">{{ item.offer_freight_bak }}</li>
            <!-- 小计 -->
            <li v-if="status > 22 && isColumnVisible('subtotal')">{{ ceil(item.offer_total) }}</li>
            <!-- 客户小计 -->
            <li v-if="status == 20 && isColumnVisible('subtotal')">{{ ceil(item.userTotal) }}</li>
            <!-- 附加服务 -->
            <li class="flex2 important" v-if="status != 21 && isColumnVisible('additionalServices')">
              <div class="attribute services">
                <el-tag v-if="Number(item.is_fba_pre) === 1" type="success" size="mini" class="fba-pre-tag">
                  标签前置处理
                </el-tag>
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span>{{ opti.num }} x {{ opti.price }}{{ opti.unit }}</span>
                      </p>
                    </div>
                  </div>
                  <div style="height: 100px">
                    <div class="row" v-for="(opti, optiIndex) in item.option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span>{{ opti.num }} x {{ opti.price }}{{ opti.unit }}</span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
              <div class="edit" v-if="status < 30 && status != 21">
                <i class="el-icon-edit-outline" @click="optionEdit(item, index)"></i>
              </div>
            </li>
            <!-- 原价计算option 定制 -->
            <li class="flex2 important"
              v-if="status == 22 && isCustomMade && isColumnVisible('originalPriceCalculationOption')">
              <div class="attribute services">
                <el-tooltip placement="bottom">
                  <div slot="content">
                    <div class="row" v-for="(opti, optiIndex) in item.bulk_option" :key="optiIndex"
                      style="margin-bottom: 3px">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span>{{ opti.num }} x {{ opti.price }}{{ opti.unit }}</span>
                      </p>
                    </div>
                  </div>
                  <div style="height: 100px">
                    <div class="row" v-for="(opti, optiIndex) in item.bulk_option" :key="optiIndex">
                      <p>
                        {{ optiIndex + 1 }}.{{ opti.name }}:
                        <span>{{ opti.num }} x {{ opti.price }}{{ opti.unit }}</span>
                      </p>
                    </div>
                  </div>
                </el-tooltip>
              </div>
              <div class="edit" v-if="status == 22">
                <i class="el-icon-edit-outline" @click="bulkOptionEdit(item, index)"></i>
              </div>
            </li>
            <!-- 标签编号 -->
            <li class="flex2" v-if="status != 21 && isColumnVisible('tagNumber')">
              <div class="attribute" style="overflow-y: auto;">
                <div v-for="(tag, tagIndex) in item.order_detail_tag" :key="tagIndex">
                  <p>类别: {{ tag.type }}</p>
                  <p>标签号:{{ tag.no }}</p>
                  <p>商品码:{{ tag.goods_no }}</p>
                </div>
              </div>
              <div class="edit" v-if="status < 30 && status != 21">
                <i class="el-icon-edit-outline" @click="tagEdit(item, index)"></i>
              </div>
            </li>
            <!-- 客户商品备注 -->
            <li class="flex2 important" v-if="status != 21 && isColumnVisible('customerProductRemarks')">

              <el-input type="textarea" v-model="item.client_remark" show-word-limit disabled class="client_remark">
              </el-input>

            </li>
            <!-- 业务回复 -->
            <li class="flex2 important y_reply" v-if="status >= 22 && isColumnVisible('businessReply')">
              <el-input v-if="status == 22" type="textarea" placeholder="请输入内容" v-model="item.y_reply" show-word-limit
                onfocus="this.select()" @input="computationalSost('y_reply', item.y_reply, item.checked, index)">
              </el-input>
              <span v-else class="text"> {{ item.y_reply }} </span>
            </li>
            <!-- 商品规格cm/g -->
            <li v-if="status > 22 && isColumnVisible('productSpecifications')" class="flex15">
              <div class="template">
                <!--尺寸  -->
                <p>{{ $t("message.size") }} :{{ item.volume }}</p>
                <!-- 重量 -->
                <p>{{ $t("message.weight") }} :{{ item.weight }}</p>
              </div>
            </li>
            <!-- 业务翻译 -->
            <li v-if="isColumnVisible('businessTranslation')" class="flex2 important">
              <el-input v-if="status == 20 || status == 22" type="textarea" placeholder="请输入内容" v-model="item.y_remark"
                show-word-limit onfocus="this.select()"
                @input="computationalSost('y_remark', item.y_remark, item.checked, index)">
              </el-input>
              <span v-else class="text"> {{ item.y_remark
              }} </span>
            </li>
            <!-- 调查在库数 -->
            <li v-if="status == 21 && isColumnVisible('quoteInLibraryNumber')">
              <div class="template">
                <el-input v-model="item.confirm_num" size="mini" onfocus="this.select()"
                  @input="computationalSost('confirm_num', item.confirm_num, item.checked, index)"
                  :disabled="item.is_supplier_goods == 1"></el-input>
                <!-- 大货数量 定制 -->
                <div class="isCustomMade" v-if="isCustomMade">
                  <el-input v-model="item.bulk_quantity" size="mini" onfocus="this.select()"
                    @input="computationalSost('bulk_quantity', item.bulk_quantity, item.checked, index)"
                    :placeholder="$t('message.largeGoodsNumber')" :title="$t('message.largeGoodsNumber')"></el-input>
                </div>
              </div>

            </li>
            <!-- 调查单价 -->
            <li v-if="status == 21 && isColumnVisible('quotationUnitPrice')">
              <div class="template">
                <el-input v-model="item.confirm_price" size="mini" onfocus="this.select()"
                  @input="computationalSost('confirm_price', item.confirm_price, item.checked, index, '',)"
                  :disabled="item.is_supplier_goods == 1"></el-input>
                <!-- 大货报价 定制 -->
                <div class="isCustomMade" v-if="isCustomMade">
                  <el-input v-model="item.bulk_price" size="mini" onfocus="this.select()"
                    @input="computationalSost('bulk_price', item.bulk_price, item.checked, index)"
                    :placeholder="$t('message.bulkQuotation')" :title="$t('message.bulkQuotation')"></el-input>
                </div>
              </div>
            </li>
            <!-- 调查运费 -->
            <li v-if="status == 21 && isColumnVisible('quoteDomesticShipping')">
              <div class="template">
                <el-input v-model="item.confirm_freight" size="mini" onfocus="this.select()"
                  @input="synchronousFreight(item.confirm_freight, index,)"
                  :disabled="item.is_supplier_goods == 1"></el-input>
                <!--大货运费 定制 -->
                <div class="isCustomMade" v-if="isCustomMade">
                  <el-input v-model="item.bulk_freight" size="mini" onfocus="this.select()"
                    @input="computationalSost('bulk_freight', item.bulk_freight, item.checked, index)"
                    :placeholder="$t('message.bulkShippingCost')" :title="$t('message.bulkShippingCost')"></el-input>
                </div>
              </div>
            </li>
            <!-- 确认小计 -->
            <li v-if="status == 21 && isColumnVisible('subtotal')">
              {{ ceil((item.confirm_num * item.confirm_price + (item.confirm_freight - 0))) }}
            </li>
            <!-- 参考单价 -->
            <li v-if="status == 21 && isColumnVisible('referenceUnitPrice')">
              <div class="template">
                {{ item.lower_confirm_dicker_price }}
                <p v-if="item.config_price_goods_detail">
                  底价：<span style="color: #B4272D;font-weight: 600;">
                    {{ item.config_price_goods_detail ? item.config_price_goods_detail.price : '' }}
                  </span>
                </p>
              </div>
            </li>
            <!-- 实际采购价 -->
            <li v-if="status == 21 && isColumnVisible('confirmPurchasePrice')">
              <el-input v-model="item.confirm_dicker_price" size="mini" onfocus="this.select()"
                @input="computationalSost('confirm_dicker_price', item.confirm_dicker_price, item.checked, index, '',)"
                :disabled="item.is_supplier_goods == 1"></el-input>
            </li>
            <!-- 确认国内运费 -->
            <li v-if="status == 21 && isColumnVisible('confirmDomesticShipping')">
              <el-input v-model="item.confirm_dicker_freight" size="mini" onfocus="this.select()"
                @input="computationalSost('confirm_dicker_freight', item.confirm_dicker_freight, item.checked, index, false,)"
                :disabled="item.is_supplier_goods == 1"></el-input>
            </li>
            <!-- 单个商品尺寸.cm -->
            <li v-if="(status == 21 || status == 22) && isColumnVisible('singleItemSize')">
              <div class="template">
                <!-- 长 -->
                <p>
                  <el-input v-model="item.length" size="mini" :placeholder="$t('message.length')"
                    onfocus="this.select()"
                    @input="computationalSost('length', item.length, item.checked, index)"></el-input>
                </p>
                <!-- 宽 -->
                <p>
                  <el-input v-model="item.width" size="mini" :placeholder="$t('message.width')" onfocus="this.select()"
                    @input="computationalSost('width', item.width, item.checked, index)"></el-input>
                </p>
                <!-- 高 -->
                <p>
                  <el-input v-model="item.height" size="mini" :placeholder="$t('message.height')"
                    onfocus="this.select()"
                    @input="computationalSost('height', item.height, item.checked, index)"></el-input>
                </p>
              </div>
            </li>
            <!-- 单个重量.g -->
            <li v-if="(status == 21 || status == 22) && isColumnVisible('individualWeight')">
              <el-input v-model="item.weight" size="mini" :placeholder="$t('message.weight')" onfocus="this.select()"
                @input="computationalSost('weight', item.weight, item.checked, index, item.goods_id)"></el-input>
            </li>
            <!-- 采购备注 -->
            <li class="flex2 important"
              v-if="(status >= 21 || status == -2) && isColumnVisible('purchasingNotes')">
              <el-input v-if="status == 21" type="textarea" placeholder="请输入内容" v-model="item.g_remark" show-word-limit
                onfocus="this.select()" @input="computationalSost('g_remark', item.g_remark, item.checked)">
              </el-input>
              <span v-else class="text"> {{ item.g_remark
              }} </span>
            </li>
            <!-- 替换链接-->
            <li v-if="(status == 21 || status == 22) && isColumnVisible('replaceTheLink')">
              <div class="template">
                <!--备选 -->

                <p v-if="item.replace_goods_info">
                  <el-button size="mini" type="primary" @click="replaceGoodsInfo(item.replace_goods_info)">
                    替换</el-button>
                </p>
                <!-- 业务报价编辑 -->
                <el-button size="mini" type="primary" class="secondary" @click="editSetReplaceGoods(item, index)"
                  v-if="isAuth(160)">
                  {{ $t("message.redact") }}
                </el-button>
              </div>
            </li>
            <!-- 跟单备注-->
            <li v-if="isColumnVisible('documentaryRemarks')">
              <div>
                <!-- 设置备注 -->
                <el-button type="primary" size="mini" class="primary" @click="setRemark(item)">{{ $t('message.Settings')
                }}</el-button>
                <!-- 历史 -->
                <p style="margin-top: 10px;">
                  <el-button type="info" size="mini" @click="historyRemarkLisy(item)">{{ $t('message.history')
                  }}</el-button>
                </p>
                <!--预抽查  -->
                <p style="margin-top: 10px;" class="presetTaskCheck" v-if="item.preset_spot_list != false">
                  <presetTaskCheck :spotDetail="item.preset_spot_list" :order_sn="detail.order_sn" />
                </p>
              </div>
            </li>
            </ul>
            <!-- 左侧辅料、右侧要求由当前工种决定；业务可直接编辑三项要求。 -->
            <div v-show="item.materialExpanded" class="materialRequirements">
              <div class="materialRequirementsList">
                <MaterialInfo :list="item.material_list" :order-quantity="item.num" :user-id="user_id"
                  :editable="isAuth(757)" :removable="isAuth(757)"
                  @update-consume="updateMaterialConsume(item, $event)" @remove="removeMaterial(item, $event)" />
              </div>
              <div class="materialRequirementsRemarks" :class="{ singleRequirement: visibleRequirements.length === 1 }">
                <div v-if="visibleRequirements.includes('purchase')" class="requirementItem">
                  <label>{{ $t('message.productV2PurchaseRequirement') }}</label>
                  <el-input v-model="item.purchase_remark" type="textarea" :rows="4" resize="none"
                    :readonly="!isBusiness" @blur="savePlanRemark(item, 'purchase_remark')" />
                </div>
                <div v-if="visibleRequirements.includes('inspect')" class="requirementItem">
                  <label>{{ $t('message.productV2InspectionRequirement') }}</label>
                  <el-input v-model="item.inspect_remark" type="textarea" :rows="4" resize="none"
                    :readonly="!isBusiness" @blur="savePlanRemark(item, 'inspect_remark')" />
                </div>
                <div v-if="visibleRequirements.includes('delivery')" class="requirementItem">
                  <label>{{ $t('message.productV2AllocationRequirement') }}</label>
                  <el-input v-model="item.delivery_remark" type="textarea" :rows="4" resize="none"
                    :readonly="!isBusiness" @blur="savePlanRemark(item, 'delivery_remark')" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 操作 -->
        <div class="operate" v-if="activeName != 'delete'">
          <!--全选  -->
          <el-checkbox v-model="checked" style="margin-right: 10px" @change="allChecked">{{ $t("message.allChecked")
          }}</el-checkbox>
          <!-- 取消全选 -->
          <el-button v-if="isOperationVisible('cancelAllChecked')" size="mini" type="primary" class="dark" @click="cancelAllChecked">
            {{ $t("message.cancelAllChecked") }}
          </el-button>
          <!-- 三种批量选择独立展示，分别参与操作配置。 -->
          <el-button v-if="isOperationVisible('homogeneousGrouping')" size="mini" type="primary" class="dark"
            @click="homogeneousGrouping(isHomogeneousGrouping)">{{ $t('message.homogeneousGrouping') }}</el-button>
          <el-button v-if="isOperationVisible('sameID')" size="mini" type="primary" class="dark"
            @click="sameID">{{ $t('message.productWithTheSameId') }}</el-button>
          <el-button v-if="isOperationVisible('sameShop')" size="mini" type="primary" class="dark"
            @click="sameShop">{{ $t('message.sameStoreProduct') }}</el-button>
          <!-- 复制选中商品信息 -->
          <el-button v-if="isOperationVisible('copyText')" size="mini" type="primary" class="dark" @click="copyText">
            {{ $t("message.copySelectedProductInformation") }}
          </el-button>
          <!-- 待采购状态下，对勾选商品统一发起同一个询盘问题。 -->
          <el-button v-if="isOperationVisible('productInquiry')" size="mini" type="warning"
            @click="openGoodsInquiryCreate">
            {{ $t('message.productInquiry') }}
          </el-button>
          <!-- 删除 -->
          <el-button size="mini" type="primary" @click="deleteFromOrder" v-if="isOperationVisible('deleteFromOrder')">
            {{ $t("message.delete") }}（番）
          </el-button>
          <!-- 提出新订单 -->
          <el-button size="mini" type="primary" class="secondary" @click="placeANewOrder" v-if="isOperationVisible('placeANewOrder')">
            {{ $t("message.placeANewOrder") }}
          </el-button>
          <!-- 再提一单 -->
          <el-button size="mini" type="primary" class="secondary" @click="raiseAnotherOrder" v-if="isOperationVisible('raiseAnotherOrder')">
            {{ $t("message.raiseAnotherOrder") }}
          </el-button>
          <!-- 订单拆单 -->
          <el-button size="mini" type="primary" class="secondary" @click="splitOrder" v-if="isOperationVisible('splitOrder')">
            {{ $t("message.orderUnpacking") }}
          </el-button>
          <!-- 商品监控录入 -->
          <el-button v-if="isOperationVisible('commodityMonitoringEntry')" size="mini" type="success" @click="commodityMonitoringEntry">
            {{ $t("message.commodityMonitoringEntry") }}
          </el-button>
          <!-- 加入商品库 -->
          <el-button size="mini" type="success" @click="inventoryBatchSave" v-if="isOperationVisible('inventoryBatchSave')">
            {{ $t("message.joinProductLibrary") }}
          </el-button>
          <!-- 按勾选的订单详情商品一键创建商品管理数据 -->
          <el-button v-if="isOperationVisible('createProductManagement')" size="mini" type="success" :loading="creatingProductManagement"
            @click="createProductManagement">
            {{ $t("message.joinProductManagement") }}
          </el-button>
          <!-- 预设任务 -->
          <el-button v-if="isOperationVisible('createPresetTask')" size="mini" type="success" @click="createPresetTask">
            {{ $t("message.presetTask") }}
          </el-button>
          <el-button type="success" @click="preServiceGet" size="mini" v-if="isOperationVisible('preServiceGet')">{{
            $t("message.preServiceSet") }}</el-button>

          <!-- 辅料操作：鼠标悬停后显示标识、解除标识和绑定消耗操作 -->
          <el-dropdown v-if="isOperationVisible('materialOperation')" trigger="hover" @command="handleMaterialOperation">
            <el-button size="mini" type="success" :disabled="materialSaving">
              {{ $t("message.materialOperation") }}
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-if="isAuth(670)" command="mark" :disabled="materialSaving || markMaterialDisabled">
                {{ $t("message.markAsMaterial") }}
              </el-dropdown-item>
              <el-dropdown-item v-if="isAuth(670)" command="cancel" :disabled="materialSaving">
                {{ $t("message.cancelMaterialMark") }}
              </el-dropdown-item>
              <el-dropdown-item v-if="isAuth(757)" command="bind" :disabled="materialSaving || bindMaterialDisabled">
                {{ $t("message.bindMaterialUsage") }}
              </el-dropdown-item>
              <el-dropdown-item command="create" :disabled="materialSaving">
                {{ $t('message.createMaterial') }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>



          <!-- 下单数 -->
          <span style="margin-left:10px;font-size:20px;color:#B4272D">{{ $t("message.lowerSingular")
          }}:{{ xiandanNum }}</span>
          <!-- 报价数 -->
          <span style="margin-left:10px;font-size:20px;color:#B4272D">{{ $t("message.quotedPriceNum")
          }}:{{ baojiaNum }}</span>
          <!-- 右边按钮 -->
          <!-- 直接付款   || ((status == 22 || status == 30) && detail.user.credit > 0)-->
          <el-button size="mini" type="primary" class="fr"
            v-if="isOperationVisible('adminOrderPay')"
            @click="adminOrderPay">
            {{ $t("message.directPayments") }}
          </el-button>
          <!-- 退回待报价 -->
          <el-button size="mini" type="primary" class="fr" v-if="isOperationVisible('backToWaitOffer')" @click="backToWaitOffer">
            {{ $t("message.returnToBeQuoted") }}
          </el-button>
          <!--  业务提出-->
          <el-button size="mini" type="primary" class="fr" v-if="isOperationVisible('submitTranslate')"
            @click="submitTranslate(0)">
            {{ $t("message.businessSbumit") }}
          </el-button>

          <!--  撤回翻译-->
          <el-button size="mini" type="primary" class="fr" v-if="isOperationVisible('withdrawTranslate')" @click="isYEditing(0)">
            {{ $t('message.withdrawTranslation') }}
          </el-button>
          <!--  临时保存-->
          <el-button size="mini" type="primary" class="fr primary" v-if="isOperationVisible('saveTranslate')"
            @click="submitTranslate(1)">
            {{ $t("message.temporaryStorage") }}
          </el-button>
          <!-- 采购提出 -->
          <el-button size="mini" type="primary" class="fr" v-if="isOperationVisible('submitConfirm')" @click="submitConfirm(0)">
            {{ $t("message.procurement") }}
          </el-button>
          <!-- 提出报价 -->
          <el-button size="mini" type="primary" class="fr" v-if="isOperationVisible('makeAnOffer')" @click="makeAnOffer"
            style="margin-right: 8px;">
            {{ $t("message.makeAnOffer") }}
          </el-button>
          <!-- 临时保存 -->
          <el-button size="mini" type="primary" class="secondary fr" @click="makeAnOfferTemporaryStorage"
            v-if="isOperationVisible('saveOffer')">
            {{ $t("message.temporaryStorage") }}
          </el-button>
          <!-- 退给采购 -->
          <el-button size="mini" type="primary" class="fr" v-if="isOperationVisible('backToWaitConfirm')"
            @click="backToWaitConfirm">
            {{ $t("message.returnToPurchase") }}
          </el-button>
          <!-- 临时保存 -->
          <el-button size="mini" type="primary" class="secondary fr" @click="temporaryStorage"
            v-if="isOperationVisible('temporaryStorage')">
            {{ $t("message.temporaryStorage") }}
          </el-button>
          <!-- 获取店铺信息 -->
          <!-- <el-button size="mini" type="primary" class="secondary fr">{{ $t("message.obtainStoreInformation") }}
        </el-button> -->
          <!-- 退给业务 -->
          <el-button size="mini" type="primary" class="fr" v-if="isOperationVisible('backToWaitTranslate')"
            @click="backToWaitTranslate">
            {{ $t("message.returnService") }}
          </el-button>

        </div>
        <!-- 操作 -->
        <!-- <operate :activeName="activeName" :xiandanNum="xiandanNum" :baojiaNum="baojiaNum" :checkedList="checkedList"
          :order_detail="order_detail" :domesticSubtotal="domesticSubtotal" /> -->
        <!-- 删除列表 -->
        <deleteList v-if="activeName == 'delete'" :detail="detail.order_detail_discard" />
      </div>
      <!-- 底部 -->
      <Footer :status="status" :total="total" :orderMaterial="orderMaterial" />
    </div>
    <!-- 品名编辑 -->
    <productNameEditor v-else />
    <!-- 属性编辑 -->
    <attribute v-if="attributeDialogVisible" :detail="itemDetail" />
    <!-- 追加商品表单 -->
    <addGoods :isUser_id="true" ref="addGoods" />
    <!-- options -->
    <options v-if="optionsDialogVisible" :detail="itemDetail" :status="status" :user_id="user_id" />
    <!-- 国际运费 -->
    <freight />

    <!-- 替换链接 -->
    <replaceGoodsOfferEdit ref="replaceGoodsOfferEdit" />
    <!-- 监控商品 -->
    <monitorProductSettings ref="monitorProductSettings" :checkedList="checkedList" />
    <!--标签编号  -->
    <TagEdit ref="TagEdit" :tagData="tagData" />
    <!-- 注意事项 -->
    <getNotice ref="getNotice" />
    <!-- option数量异常 -->
    <optionPrompt ref="optionPrompt" />
    <largeSetQuantityPrompt ref="largeSetQuantityPrompt" />
    <!-- 黑名单店铺订单号 -->
    <blackShopOrder ref="blackShopOrder" />
    <!-- 设置备注 -->
    <setRemarks ref="setRemarks" :itemDetail="itemDetail" />
    <!-- 备注 -->
    <historyRemark ref="historyRemark" :itemDetail="itemDetail" />
    <!-- 备注提示 -->
    <promptRemarks ref="promptRemarks" />
    <!-- 同捆商品 -->
    <kitAssembly ref="kitAssembly" :order_detail="detail.order_detail" />
    <!-- 大货option -->
    <bulk_option ref="bulk_option" :itemDetail="itemDetail" :i="i" />
    <!-- 预设任务 -->
    <presetTask ref="presetTask" />
    <!-- 追加商品 -->
    <appendProduct ref="appendProduct" />
    <!-- 前置处理设置弹窗 -->
    <preServiceSet ref="preServiceSet" />
    <replaceLink ref="replaceLink" />
    <!-- 侵权识别详情 -->
    <tortDetectDetail ref="tortDetectDetail" />
    <!-- 从当前客户的辅料列表中选择辅料并标识商品 -->
    <MaterialSelectDialog ref="materialSelectDialog" :user-id="detail.user_id"
      :title="$t('message.confirmMarkAsMaterial')" @confirm="confirmMarkAsMaterial" />
    <!-- 为勾选商品设置辅料及单套消耗点数 -->
    <MaterialBindDialog ref="materialBindDialog" :user-id="detail.user_id" @confirm="confirmBindMaterial" />
    <!-- 使用辅料登记弹窗，预填当前勾选商品的信息。 -->
    <MaterialForm ref="materialFormDialog" :type-list="materialTypeList" />
    <!-- 商品询盘提交及单番询盘记录 -->
    <goodsInquiryCreate ref="goodsInquiryCreate" @saved="orderDetails" />
    <!-- 单番询盘记录 -->
    <goodsInquiryRecords ref="goodsInquiryRecords" />
    <!-- 表头设置：只维护列显隐，保存到账号级表头配置。 -->
    <columnSettingsDialog :visible.sync="columnSettingsVisible" :columns="availableColumnOptions"
      :value="visibleColumns" @save="saveColumnSettings" />
    <!-- 操作设置：独立弹窗实例，只列出当前状态、权限可用的操作。 -->
    <columnSettingsDialog :visible.sync="operationSettingsVisible" :columns="availableOperationOptions"
      :value="visibleOperations" :title="$t('message.customOperations')"
      :select-all-label="$t('message.showAllOperations')" @save="saveOperationSettings" />
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import orderHeader from "./components/header";
import attribute from "./components/attribute";
import addGoods from "./components/addGoods";
import options from "./components/options";
import freight from "./components/freight";
import setReplaceGoods from "./components/setReplaceGoods";
import replaceGoodsOfferEdit from "./components/replaceGoodsOfferEdit";
import deleteList from "./components/deleteList";
import InternationalFreight from "./components/InternationalFreight";
import monitorProductSettings from "./components/monitorProductSettings";
import statistics from "./components/statistics";
import Footer from "./components/footer";
import TagEdit from "./components/tagEdit.vue";
import optionPrompt from './components/optionPrompt'
import largeSetQuantityPrompt from './components/largeSetQuantityPrompt'
import blackShopOrder from './components/blackShopOrder'
import historyRemark from '@/components/documentary/historyRemark'
import setRemarks from '@/components/documentary/setRemark'
import promptRemarks from '@/components/documentary/promptRemarks'
import productNameEditor from "./components/productNameEditor";
import kitAssembly from './components/kitAssembly'
import operate from './components/operate'
import bulk_option from './components/bulk_option'
import presetTask from '@/components/presetTask/index'
import presetTaskCheck from '@/components/common/presetTaskCheck'
import appendProduct from './components/appendProduct'
import preServiceSet from './components/preServiceSet'
import replaceLink from '@/components/common/replaceLink'
import tortDetectDetail from './orderPaymentDetail/tortDetectDetail.vue'
import MaterialInfo from '@/components/common/materialInfo'
import MaterialMarkTip from '@/components/common/materialMarkTip'
import { getPlanRemarkSnapshot, normalizePlanRemark, shouldExpandPlanRemark } from '@/utlis/materialRemark'
import MaterialSelectDialog from '@/components/common/materialSelectDialog'
import MaterialBindDialog from '@/components/common/materialBindDialog'
import MaterialForm from '@/views/home/warehouse/material/components/materialForm'
import goodsInquiryCreate from './components/goodsInquiryCreate'
import goodsInquiryRecords from './components/goodsInquiryRecords'
import columnSettingsDialog from './components/columnSettingsDialog'
var title = ''

import { mapState } from "vuex";
import NP from 'number-precision' //NP.strip 处理浮点数

// 选择列固定显示，其余订单明细列均可按账号配置。
const columnOptions = [
  { key: 'sorting', labelKey: 'message.mash' },
  { key: 'shopInformation', labelKey: 'message.storeInformation' },
  { key: 'picture', labelKey: 'message.pic' },
  { key: 'customerProductAttributes', labelKey: 'message.attributesOfGoodsPlacedByCustomers', excludeStatuses: [21] },
  { key: 'businessEditAttributes', labelKey: 'message.businessEditAttributes' },
  { key: 'orderData', labelKey: 'message.orderData' },
  { key: 'quoteInLibraryNumber', labelKey: 'message.quoteInLibraryNumber', statuses: [21, 22] },
  { key: 'quotationUnitPrice', labelKey: 'message.quotationUnitPrice', statuses: [21, 22] },
  { key: 'quoteDomesticShipping', labelKey: 'message.quoteDomesticShipping', minStatus: 21 },
  { key: 'quotedPrice', labelKey: 'message.quotedPrice', minStatus: 23 },
  { key: 'subtotal', labelKey: 'message.subtotal', statuses: [20, 21], minStatus: 23 },
  { key: 'additionalServices', labelKey: 'message.additionalServices', excludeStatuses: [21] },
  { key: 'originalPriceCalculationOption', labelKey: 'message.originalPriceCalculationOption', statuses: [22], customMadeOnly: true },
  { key: 'tagNumber', labelKey: 'message.tagNumber', excludeStatuses: [21] },
  { key: 'customerProductRemarks', labelKey: 'message.customerProductRemarks', excludeStatuses: [21] },
  { key: 'businessReply', labelKey: 'message.businessReply', minStatus: 22 },
  { key: 'productSpecifications', labelKey: 'message.productSpecifications', minStatus: 23 },
  { key: 'businessTranslation', labelKey: 'message.businessTranslation' },
  { key: 'referenceUnitPrice', labelKey: 'message.referenceUnitPrice', statuses: [21] },
  { key: 'confirmPurchasePrice', labelKey: 'message.confirmPurchasePrice', statuses: [21] },
  { key: 'confirmDomesticShipping', labelKey: 'message.confirmDomesticShipping', statuses: [21] },
  { key: 'singleItemSize', labelKey: 'message.singleItemSize', statuses: [21, 22] },
  { key: 'individualWeight', labelKey: 'message.individualWeight', statuses: [21, 22] },
  { key: 'purchasingNotes', labelKey: 'message.purchasingNotes', statuses: [-2], minStatus: 21 },
  { key: 'replaceTheLink', labelKey: 'message.replaceTheLink', statuses: [21, 22] },
  { key: 'documentaryRemarks', labelKey: 'message.documentaryRemarks' },
]
const defaultColumns = columnOptions.map(item => item.key)

// 底部操作沿用各自的状态、权限条件，全选及数量统计固定展示。
// key 对应按钮显隐及存储字段，labelKey/suffix 用于设置弹窗的名称展示。
// statuses 指定可用状态，beforeStatus/minStatus 指定状态边界；未配置时沿用通用操作。
// auth 要求单项权限，anyAuth 满足任一权限即可；两个 Only 标记保留询盘账号和付款授权限制。
const operationOptions = [
  // 选择操作拆成独立按钮，允许分别控制同分类、同 ID、同店铺的显隐。
  { key: 'cancelAllChecked', labelKey: 'message.cancelAllChecked' },
  { key: 'homogeneousGrouping', labelKey: 'message.homogeneousGrouping' },
  { key: 'sameID', labelKey: 'message.productWithTheSameId' },
  { key: 'sameShop', labelKey: 'message.sameStoreProduct' },
  { key: 'copyText', labelKey: 'message.copySelectedProductInformation' },
  // 询盘仅限待采购状态，具体开放账号由 canCreateGoodsInquiry 判断。
  { key: 'productInquiry', labelKey: 'message.productInquiry', statuses: [21], inquiryOnly: true },
  { key: 'deleteFromOrder', labelKey: 'message.delete', suffix: '（番）', auth: 156 },
  { key: 'placeANewOrder', labelKey: 'message.placeANewOrder', auth: 154 },
  { key: 'raiseAnotherOrder', labelKey: 'message.raiseAnotherOrder', auth: 154 },
  { key: 'splitOrder', labelKey: 'message.orderUnpacking', beforeStatus: 30 },
  { key: 'commodityMonitoringEntry', labelKey: 'message.commodityMonitoringEntry' },
  { key: 'inventoryBatchSave', labelKey: 'message.joinProductLibrary', auth: 566 },
  { key: 'createProductManagement', labelKey: 'message.joinProductManagement', auth: 774 },
  { key: 'createPresetTask', labelKey: 'message.presetTask' },
  { key: 'preServiceGet', labelKey: 'message.preServiceSet', minStatus: 22 },
  // 辅料操作按菜单整体配置，菜单内各子操作继续保留原权限校验。
  { key: 'materialOperation', labelKey: 'message.materialOperation', anyAuth: [670, 757] },
  // 付款及流转操作按各自原有状态、权限开放，配置不能放宽这些条件。
  { key: 'adminOrderPay', labelKey: 'message.directPayments', statuses: [22, 30], auth: 164, payAuthorizedOnly: true },
  { key: 'backToWaitOffer', labelKey: 'message.returnToBeQuoted', statuses: [30], auth: 165 },
  { key: 'submitTranslate', labelKey: 'message.businessSbumit', statuses: [20], auth: 155 },
  { key: 'withdrawTranslate', labelKey: 'message.withdrawTranslation', statuses: [20] },
  { key: 'saveTranslate', labelKey: 'message.temporaryStorage', statuses: [20], auth: 155 },
  { key: 'submitConfirm', labelKey: 'message.procurement', statuses: [21], auth: 157 },
  { key: 'makeAnOffer', labelKey: 'message.makeAnOffer', statuses: [22], auth: 163 },
  { key: 'saveOffer', labelKey: 'message.temporaryStorage', statuses: [22], auth: 163 },
  { key: 'backToWaitConfirm', labelKey: 'message.returnToPurchase', statuses: [22], auth: 162 },
  { key: 'temporaryStorage', labelKey: 'message.temporaryStorage', statuses: [21], auth: 157 },
  { key: 'backToWaitTranslate', labelKey: 'message.returnService', statuses: [21], auth: 159 }
]

export default {
  components: {
    detailHeader,
    orderHeader,
    attribute,
    addGoods,
    options,
    freight,
    setReplaceGoods,
    replaceGoodsOfferEdit,
    deleteList,
    InternationalFreight,
    monitorProductSettings,
    statistics,
    Footer,
    TagEdit,
    optionPrompt,
    largeSetQuantityPrompt,
    blackShopOrder,
    setRemarks,
    historyRemark,
    promptRemarks,
    productNameEditor,
    kitAssembly,
    operate,
    bulk_option,
    presetTask,
    presetTaskCheck,
    appendProduct,
    preServiceSet,
    replaceLink,
    tortDetectDetail,
    MaterialInfo,
    MaterialMarkTip,
    MaterialSelectDialog,
    MaterialBindDialog,
    MaterialForm,
    goodsInquiryCreate,
    goodsInquiryRecords,
    columnSettingsDialog
  },
  metaInfo() {
    return {
      title: '订单' + this.title,
    };
  },
  data() {
    return {
      columnOptions,
      visibleColumns: [...defaultColumns],
      columnSettingsVisible: false,
      operationSettingsVisible: false, // 自定义操作弹窗，与表头弹窗分别控制。
      operationVisibility: {}, // 当前账号、状态的操作显隐；仅 false 表示隐藏，新增项默认显示。
      creatingProductManagement: false,
      planRemarkSaving: false,
      isProductNameEditor: false,// 是否品名编辑
      orderMaterial: 0,// 品名数量
      user_id: this.$route.query.order_sn.split('-')[1],
      isHomogeneousGrouping: true,
      order_sn: this.$route.query.order_sn,
      activeName: "", //列表状态
      show: false,
      order_detail: [],//排序用
      // detail: {
      //   order_detail: [],
      //   order_detail_discard: [],
      // },
      service_rate: 0, // 手续费汇率
      exchange_rate: 0, // 汇率
      status: 0,
      checked: false,
      textarea: "",
      val: "",
      attributeDialogVisible: false, //属性编辑
      addGoodsDialogVisible: false, //追加商品表单
      optionsDialogVisible: false, //options
      freightDialogVisible: false, //国际运费预估

      //统计
      total: {
        goodsAmount: 0,
        domesticFreight: 0,
        additionalServiceCharge: 0,
        totalWeight: 0,
        totalVolume: 0,
      },
      loading: false,
      i: 0, //要修改的索引
      itemDetail: {}, //要修改项
      replaceGoodsOfferList: [],//替换链接业务报价编辑列表
      forecastExpense: {},// 其它物流方式预估运费查看 参数
      xiandanNum: 0,//下单总数
      baojiaNum: 0,//报价总数
      checkedList: [],//选中的列表
      tagData: {},//标签编号
      title: '',
      historyRemarkData: [],// 历史跟单备注
      userRole: localStorage.getItem('japanUserRoleStatus') == 1, //是否是业务工种
      workType: Number(localStorage.getItem('japanUserRoleStatus')),
      currentAdminId: Number(JSON.parse(localStorage.getItem('japanUserRoleInfo') || '{}').id),
      materialSaving: false,
      materialTypeList: [],
      markMaterialGoods: [],
      bindMaterialGoods: [],
    };
  },
  computed: {
    ...mapState({
      logisticsList: (state) => state.porderDetail.logisticsList,
      detail: (state) => state.orderDetail.detail,
      orderStatusList: (state) => state.orderStatusList,
      rate: (state) => state.rate,
    }),
    // 采购只看采购、配货只看配货；业务和财务查看全部要求。
    visibleRequirements() {
      switch (this.workType) {
        case 2: return ['purchase']
        case 5: return ['delivery']
        case 1: // 业务
        case 3: // 财务
        default: return ['purchase', 'inspect', 'delivery']
      }
    },
    isBusiness() {
      return this.workType === 1
    },
    materialRows() {
      return Array.isArray(this.detail.order_detail) ? this.detail.order_detail : []
    },
    allMaterialsExpanded() {
      return this.materialRows.length > 0 && this.materialRows.every(item => item.materialExpanded)
    },
    // 只显示当前订单状态下实际存在的可配置列。
    availableColumnOptions() {
      const status = Number(this.status)
      return this.columnOptions.filter(item => {
        if (item.excludeStatuses && item.excludeStatuses.includes(status)) return false
        if (item.statuses || item.minStatus !== undefined) {
          const matchedStatus = (item.statuses || []).includes(status)
            || (item.minStatus !== undefined && status >= item.minStatus)
          if (!matchedStatus) return false
        }
        if (item.customMadeOnly && !this.isCustomMade) return false
        return true
      })
    },
    // 配置中仅出现当前状态和权限实际可用的操作。
    availableOperationOptions() {
      const status = Number(this.status)
      return operationOptions.filter(item => {
        // 先筛选业务状态，再校验权限及询盘、付款的额外限制。
        if (item.statuses && !item.statuses.includes(status)) return false
        if (item.beforeStatus !== undefined && status >= item.beforeStatus) return false
        if (item.minStatus !== undefined && !(Number(this.detail.status) >= item.minStatus)) return false
        if (item.auth && !this.isAuth(item.auth)) return false
        if (item.anyAuth && !item.anyAuth.some(auth => this.isAuth(auth))) return false
        if (item.inquiryOnly && !this.canCreateGoodsInquiry) return false
        if (item.payAuthorizedOnly && !(this.detail.user && this.detail.user.is_pay_authorized)) return false
        return true
      })
    },
    // 在实际可用操作上叠加个人显隐配置，未保存过的新操作默认显示。
    visibleOperations() {
      return this.availableOperationOptions.filter(item => this.operationVisibility[item.key] !== false).map(item => item.key)
    },
    // 已绑定辅料的商品不能再标识为辅料
    markMaterialDisabled() {
      return this.checkedList.some(item => this.hasBoundMaterial(item))
    },
    // 已标识为辅料的商品不能再绑定辅料使用
    bindMaterialDisabled() {
      return this.checkedList.some(item => this.isMaterial(item))
    },
    // 商品询盘当前仅开放给指定账号。
    canCreateGoodsInquiry() {
      return [180, 13].includes(this.currentAdminId)
    },
    // 国内小计
    domesticSubtotal() {
      let num = 0
      num = (
        this.total.goodsAmount -
        0 +
        (this.total.domesticFreight - 0) +
        (this.poundage - 0) +
        (this.total.additionalServiceCharge - 0) +
        (this.detail.other_price - 0)
      );
      return NP.strip(num)
    },
    // 手续费 单番手续费
    poundage() {
      let num = 0
      this.detail.order_detail.forEach((item) => {
        if (this.status == 20) {
          num += NP.strip(item.price * item.num * item.service_rate)
        } else if (this.status == 21) {
          num += NP.strip(item.confirm_num * item.confirm_price * item.service_rate)
        } else {

          num += NP.strip(item.offer_price * item.offer_num * item.service_rate)
        }
      })

      return this.ceil((NP.strip(num)));
    },
    // 是否定制
    isCustomMade() {
      let ids = [329990, 331032]
      let flag = ids.some(item => item == this.user_id)
      return flag
    },
  },
  watch: {
    // 状态变化后关闭旧配置弹窗，并读取新状态的操作配置，避免跨状态保存。
    status() {
      this.operationSettingsVisible = false
      this.loadOperationSettings()
    }
  },
  created() {
    // 初始化时分别恢复表头和操作配置，两种配置使用不同的存储键。
    this.loadColumnSettings()
    this.loadOperationSettings()
    this.orderDetails();
    this.orderMaterialPreview()
    this.$store.dispatch("getLogisticsList"); //物流方式获取
  },
  methods: {
    // 不同账号、订单状态分别保存，权限仍以当前账号为准。
    getOperationStorageKey() {
      return `orderDetail:operationConfig:v1:${this.currentAdminId || 'default'}:${this.status}`
    },
    // 读取当前账号、状态的本地配置；先清空旧值，避免无配置时沿用上一个状态。
    loadOperationSettings() {
      this.operationVisibility = {}
      try {
        const savedConfig = JSON.parse(localStorage.getItem(this.getOperationStorageKey()) || '{}')
        if (savedConfig.operations) this.operationVisibility = savedConfig.operations
      } catch (error) {
        // 配置损坏时默认显示当前可用的全部操作。
      }
    },
    // 模板统一通过最终可见操作判断按钮显隐，个人配置不绕过状态和权限筛选。
    isOperationVisible(key) {
      return this.visibleOperations.includes(key)
    },
    // 保存当前可配置项的勾选结果，只更新本账号、本状态的操作配置。
    saveOperationSettings(selectedOperations) {
      // 保留当前因权限不可见的配置，避免权限恢复后丢失原来的个人选择。
      const operations = { ...this.operationVisibility }
      this.availableOperationOptions.forEach(item => {
        operations[item.key] = selectedOperations.includes(item.key)
      })
      this.operationVisibility = operations
      localStorage.setItem(this.getOperationStorageKey(), JSON.stringify({ version: 1, operations }))
    },
    // 订单详情使用独立的账号级表头配置。
    getColumnStorageKey() {
      let userId = 'default'
      try {
        const userInfo = JSON.parse(localStorage.getItem('japanUserRoleInfo') || '{}')
        userId = userInfo.id || 'default'
      } catch (error) {
        userId = 'default'
      }
      return `orderDetail:columnConfig:v1:${userId}`
    },
    // 无配置、配置损坏或新增列时，默认显示全部。
    loadColumnSettings() {
      try {
        const savedConfig = JSON.parse(localStorage.getItem(this.getColumnStorageKey()) || '{}')
        if (savedConfig.columns) {
          this.visibleColumns = defaultColumns.filter(key => savedConfig.columns[key] !== false)
        }
      } catch (error) {
        // 本地配置损坏时使用默认展示方案
      }
    },
    // 判断列是否可见
    isColumnVisible(key) {
      return this.visibleColumns.includes(key)
    },
    // 保存列配置
    saveColumnSettings(selectedColumns) {
      const availableKeys = this.availableColumnOptions.map(item => item.key)
      // 仅更新当前状态可选列，保留其他状态专属列的配置。
      this.visibleColumns = defaultColumns.filter(key => {
        return availableKeys.includes(key)
          ? selectedColumns.includes(key)
          : this.visibleColumns.includes(key)
      })
      const columns = defaultColumns.reduce((result, key) => {
        result[key] = this.visibleColumns.includes(key)
        return result
      }, {})
      localStorage.setItem(this.getColumnStorageKey(), JSON.stringify({
        version: 1,
        columns,
      }))
    },
    // 勾选商品后批量发起询盘，提交参数只包含订单明细 ID 和统一问题。
    openGoodsInquiryCreate() {
      if (!this.canCreateGoodsInquiry) return
      if (!this.checkedList.length) {
        this.$message.error(this.$t('message.selectableOperationalList'))
        return
      }
      this.$refs.goodsInquiryCreate.open(this.checkedList.map(item => item.id))
    },
    // 单番询盘标识只负责打开记录弹窗，详情由组件按订单明细 ID 请求。
    openGoodsInquiryRecords(item) {
      this.$refs.goodsInquiryRecords.open(item.id)
    },
    // 辅料下拉菜单仅负责分发操作，具体校验和保存沿用原有方法
    handleMaterialOperation(command) {
      if ((command === 'mark' || command === 'cancel') && !this.isAuth(670)) return
      if (command === 'bind' && !this.isAuth(757)) return
      if (command === 'mark') this.markAsMaterial()
      if (command === 'cancel') this.cancelMaterialMark()
      if (command === 'bind') this.bindMaterialUsage()
      if (command === 'create') this.createMaterial()
    },
    // 一个番创建一份辅料主档，不自动改变原商品的标识或绑定。
    createMaterial() {
      if (this.materialSaving || (!this.isAuth(670) && !this.isAuth(757))) return
      const list = this.getCheckedMaterialGoods()
      if (!list.length) return
      if (list.length !== 1) {
        this.$message.error(this.$t('message.selectOneProductToCreateMaterial'))
        return
      }
      const item = list[0]
      this.$api.warehouseApi.materialTypeList().then(res => {
        this.materialTypeList = res.data || []
      })
      this.$refs.materialFormDialog.openAdd({
        user_id: this.detail.user_id,
        name_trans: item.goods_title || '',
        main_image: item.pic || ''
      }, this.detail.user ? this.detail.user.realname : '')
    },
    // 当前勾选商品，辅料相关批量操作统一从订单明细中获取
    getCheckedMaterialGoods() {
      const list = this.detail.order_detail.filter(item => item.checked)
      if (!list.length) {
        this.$message.error(this.$t('message.selectableOperationalList'))
      }
      return list
    },
    // 订单详情的辅料标识详情位于 material，ID 同时兼容顶层 material_id
    isMaterial(item) {
      return Number(item.is_material) === 1 || Boolean(item.material_id) || Boolean(item.material && item.material.id)
    },
    // material_bind 是订单详情的辅料绑定来源，每次初始化都同步到公共组件展示列表
    initMaterialState(item) {
      if (item.materialExpanded === undefined) {
        this.$set(item, 'materialExpanded', shouldExpandPlanRemark(item, this.visibleRequirements, this.isBusiness))
      }
      if (item._planRemarkSnapshot === undefined) {
        this.$set(item, '_planRemarkSnapshot', getPlanRemarkSnapshot(item))
      }
      this.$set(item, 'material_list', this.getOrderMaterialList(item))
    },
    // order.detail 的 material_bind 绑定数据转换为公共辅料卡片所需结构
    getOrderMaterialList(item) {
      if (!Array.isArray(item.material_bind)) return []
      return item.material_bind.map(binding => {
        const material = binding.material_detail || binding.material || {}
        // 绑定记录 ID 不是辅料主档 ID，库位查询等操作只使用主档字段。
        const materialId = binding.material_id || material.id
        return {
          ...material,
          ...binding,
          id: materialId,
          material_id: materialId,
          type: material.type || binding.type || {},
          consume: binding.consume !== undefined && binding.consume !== null ? binding.consume : 1
        }
      })
    },
    // 判断订单商品是否已绑定辅料使用
    hasBoundMaterial(item) {
      if (Array.isArray(item.material_list)) return item.material_list.length > 0
      return Array.isArray(item.material_bind) && item.material_bind.length > 0
    },
    // 打开当前客户辅料列表，选择后将勾选商品标识为辅料
    markAsMaterial() {
      if (!this.isAuth(670)) return
      const list = this.getCheckedMaterialGoods()
      if (!list.length) return
      if (list.some(item => this.hasBoundMaterial(item))) {
        this.$message.error(this.$t('message.boundMaterialCannotMark'))
        return
      }
      this.markMaterialGoods = list
      const selectedList = list.length === 1 && list[0].material_detail ? [list[0].material_detail] : []
      this.$refs.materialSelectDialog.open(selectedList)
    },
    // 调用 sortingSignMaterial 实时保存辅料标识
    confirmMarkAsMaterial(list) {
      if (!this.isAuth(670)) return
      const material = list[0]
      const materialId = material && material.id
      if (!materialId || !this.markMaterialGoods.length) return
      if (this.markMaterialGoods.some(item => this.hasBoundMaterial(item))) {
        this.$message.error(this.$t('message.boundMaterialCannotMark'))
        return
      }
      const datas = {
        user_id: this.detail.user_id,
        list: this.markMaterialGoods.map(item => ({
          order_detail_id: item.id,
          material_id: materialId
        }))
      }
      this.saveMaterialChange(() => this.$api.warehouseApi.sortingSignMaterial(datas))
    },
    // 调用 sortingNotSignMaterial 实时解除勾选商品的辅料标识
    cancelMaterialMark() {
      if (!this.isAuth(670)) return
      const list = this.getCheckedMaterialGoods()
      if (!list.length) return
      this.$confirm(
        this.$t('message.confirmCancelMaterialMark'),
        this.$t('message.prompt'),
        {
          confirmButtonText: this.$t('message.ok'),
          cancelButtonText: this.$t('message.cancel'),
          type: 'warning'
        }
      ).then(() => {
        this.saveMaterialChange(() => this.$api.warehouseApi.sortingNotSignMaterial({
          orderDetailIds: list.map(item => item.id)
        }))
      }).catch(() => { })
    },
    // 打开辅料绑定弹窗；单个商品回显当前绑定，多商品从空列表开始选择
    bindMaterialUsage() {
      if (!this.isAuth(757)) return
      const list = this.getCheckedMaterialGoods()
      if (!list.length) return
      if (list.some(item => this.isMaterial(item))) {
        this.$message.error(this.$t('message.markedMaterialCannotBind'))
        return
      }
      list.forEach(item => this.initMaterialState(item))
      this.bindMaterialGoods = list
      const selectedList = list.length === 1 ? list[0].material_list : []
      this.$refs.materialBindDialog.open(selectedList)
    },
    // 调用 sortingBindMaterial 为勾选商品实时保存辅料及单套消耗点数
    confirmBindMaterial(selectedList) {
      if (!this.isAuth(757)) return
      if (!this.bindMaterialGoods.length) return
      if (this.bindMaterialGoods.some(item => this.isMaterial(item))) {
        this.$message.error(this.$t('message.markedMaterialCannotBind'))
        return
      }
      const materialList = selectedList.map(item => ({
        material_id: item.material_id || item.id,
        consume: item.consume
      }))
      const list = {}
      this.bindMaterialGoods.forEach(item => {
        list[item.id] = materialList
      })
      this.saveMaterialChange(() => this.$api.warehouseApi.sortingBindMaterial({
        user_id: this.detail.user_id,
        list
      }))
    },
    // 单行展开或收起辅料信息
    toggleMaterial(item) {
      this.initMaterialState(item)
      item.materialExpanded = !item.materialExpanded
    },
    // 一键控制当前详情内全部辅料及要求区域。
    toggleAllMaterials() {
      const expanded = !this.allMaterialsExpanded
      this.materialRows.forEach(item => {
        this.initMaterialState(item)
        item.materialExpanded = expanded
      })
    },
    // 失焦保存当前修改的要求：有勾选时同步选中商品，无勾选时只改当前商品。
    async savePlanRemark(item, col) {
      if (!this.isBusiness || this.planRemarkSaving) return
      const remark = normalizePlanRemark(item[col])
      if (item._planRemarkSnapshot && item._planRemarkSnapshot[col] === remark) return

      const selectedList = this.detail.order_detail.filter(row => row.checked)
      const list = selectedList.length ? selectedList : [item]
      // 在未勾选行输入时，仅将内容用于批量修改，当前未勾选行恢复原值。
      if (!list.includes(item)) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
      }
      const changedList = list.filter(row => !row._planRemarkSnapshot || row._planRemarkSnapshot[col] !== remark)
      if (!changedList.length) return

      this.planRemarkSaving = true
      try {
        // 批量 ID 一次提交，无勾选时数组中仅包含当前商品 ID。
        const res = await this.$api.orderApi.updatePlanRemark({
          order_detail_id: changedList.map(row => row.id),
          col,
          remark,
        }, { isLoading: true, resolveError: true })
        if (res.code != 0 || res.success === false) {
          item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
          return
        }
        // 整批保存成功后更新各行及快照，不改动其他要求和未勾选商品。
        changedList.forEach(row => {
          this.$set(row, col, remark)
          if (!row._planRemarkSnapshot) this.$set(row, '_planRemarkSnapshot', getPlanRemarkSnapshot(row))
          row._planRemarkSnapshot[col] = remark
          this.$set(row, 'materialExpanded', true)
        })
        this.$message.success(res.msg)
      } catch (error) {
        item[col] = item._planRemarkSnapshot ? item._planRemarkSnapshot[col] : ''
        // 请求失败由公共请求层提示，其他行保持原值。
      } finally {
        this.planRemarkSaving = false
      }
    },
    // 修改单条消耗后提交该商品完整辅料列表，避免覆盖其他绑定
    updateMaterialConsume(item, data) {
      if (!this.isAuth(757)) return
      const materialList = item.material_list.map((material, index) => ({
        material_id: material.material_id || material.id,
        consume: index === data.index ? data.consume : material.consume
      }))
      this.saveMaterialChange(() => this.$api.warehouseApi.sortingBindMaterial({
        user_id: this.detail.user_id,
        list: {
          [item.id]: materialList
        }
      }))
    },
    // 公共卡片已完成二次确认，这里实时解除当前商品的一条辅料绑定
    removeMaterial(item, index) {
      if (!this.isAuth(757)) return
      const material = item.material_list[index]
      const materialId = material && (material.material_id || material.id)
      if (!materialId) return
      this.saveMaterialChange(() => this.$api.warehouseApi.sortingUnbindMaterial({
        user_id: this.detail.user_id,
        list: {
          [item.id]: [materialId]
        }
      }))
    },
    // 保存成功后重新读取订单详情，以服务端数据作为页面最终状态
    saveMaterialChange(save) {
      this.materialSaving = true
      return save().then(res => {
        this.$message.success(res.msg)
        return this.orderDetails()
      }).then(() => {
        this.markMaterialGoods = []
        this.bindMaterialGoods = []
        this.checkedList = []
        this.checked = false
      }).finally(() => {
        this.materialSaving = false
      })
    },
    getTitle(status) {
      this.title = this.orderStatusList.find(item => item.key == status).value
    },
    //获取详情
    orderDetails() {
      let datas = {
        order_sn: this.order_sn,
        is_japanfirm: this.$route.query.is_japanfirm,
      }
      return this.$api.orderApi
        .orderDetails(datas)
        .then((res) => {
          // 注意事项
          if (res.data.status == 21) {
            this.$refs.getNotice.getNotice(res.data.user_id, "采购注意事项")
          } else if (res.data.status < 30) {
            this.$refs.getNotice.getNotice(res.data.user_id, "业务注意事项")
          }
          // 付款后强行关闭
          if (res.data.status > 40) {
            this.$router.push('/orderPaymentDetail?order_sn=' + this.order_sn)
            return false
          }
          this.checked = false
          this.checkedList = []
          res.data.order_detail.forEach(item => {
            item.checked = false
            this.initMaterialState(item)
            if (res.data.status == 20) {
              if (item.client_remark != null && item.client_remark != '' && item.y_remark == '') {
                item.y_remark = item.client_remark
              }
            }
            item.bulk_option = []
            item.bulk_quantity = ''
            item.bulk_freight = ''
            item.bulk_price = ''
            // 大货报价用
            if (this.isCustomMade) {
              item.bulk_option = item.order_detail_bulk != null ? item.order_detail_bulk.bulk_option : []
              item.bulk_quantity = item.order_detail_bulk != null ? item.order_detail_bulk.bulk_quantity : 1000
              item.bulk_freight = item.order_detail_bulk != null ? item.order_detail_bulk.bulk_freight : ''
              item.bulk_price = item.order_detail_bulk != null ? item.order_detail_bulk.bulk_price : ''

            }
          })
          this.$forceUpdate();
          this.service_rate = res.data.service_rate - 0;
          this.exchange_rate = res.data.exchange_rate - 0;
          this.status = res.data.status;
          this.dataProcessing(res.data);
          this.show = true;
          if (res.data.status == 22) {
            this.$nextTick(() => this.$refs.largeSetQuantityPrompt.open(res.data.order_detail))
          }
          if (res.data.status == 20 && res.data.is_y_editing == 0) {
            this.$alert("开始翻译后，客户不能修改订单", "提示", {
              confirmButtonText: "确定",
              center: true,
              showClose: false,
              lockScroll: false,
              callback: action => {
                this.isYEditing(1)
              }
            });
          }
          if (res.data.status == 22) {
            this.$refs.optionPrompt.promptDetection(res.data.order_detail)
          }
          this.getTitle(res.data.status)
          // 问题店铺或者诈骗团伙
          if (res.data.status == 20 || res.data.status == 21) {
            this.$refs.blackShopOrder.blackShopOrder()
          }

          // 查看跟单备注
          this.$refs.promptRemarks.lookPromptRemarks(res.data.order_detail)
        });
    },
    // 数据处理
    dataProcessing(detail) {
      this.baojiaNum = 0 //报价数
      this.xiandanNum = 0 //下单数
      detail.order_detail.forEach((item, index) => {

        let itemData = this.detail.order_detail.find(items => items.set_detail_id == item.id) //查询是否是组套主商品
        if (itemData) {
          item.isZhu = true
          item.group = itemData.group
          console.log(item);
        }
        // console.log(item.set_detail_id, item.group);
        item.weight = item.weight / 1000
        if (item.detail_y == null) {
          item.detail_y = item.detail;
        }
        item.userTotal = (item.num * item.price); //客户小计
        if (!item.volume) {
          item.volume = "0x0x0";
        }
        item.volumes = item.volume.split("x");
        item.length = item.volumes[0];
        item.width = item.volumes[1];
        item.height = item.volumes[2];
        item.offer_num = item.confirm_num; //报价数量
        item.offer_freight = item.confirm_freight; //报价运费
        item.offer_price = item.confirm_price; // 报价单价
        item.offer_total =
          item.offer_num_bak * item.offer_price_bak + (item.offer_freight_bak - 0);
        // if (index % 2 == 0) {
        //   item.service_rate = 0.04
        // }
        this.xiandanNum += item.num - 0
        this.baojiaNum += item.offer_num - 0
        if (detail.status == 21 && detail.is_g_temp_save == 0) {
          // console.log(item.confirm_num);
          item.confirm_num = item.confirm_num > 0 ? item.confirm_num : item.num
          // 没报价默认单价
          item.confirm_price = item.confirm_price != 0 ? item.confirm_price : item.price
          // 没有实际采购价默认报价单价
          item.confirm_dicker_price = item.confirm_dicker_price != 0 ? item.confirm_dicker_price : item.confirm_price
        }
        item.client_modify_field = item.client_modify_field == null ? [] : item.client_modify_field
      });
      this.order_detail = JSON.parse(JSON.stringify(detail.order_detail))
      // 工厂直发用
      detail.order_augment = detail.order_augment == null ? {} : detail.order_augment
      detail.order_augment.is_y_performance = detail.order_augment.is_y_performance ? true : false //是否计算业务绩效
      detail.order_augment.is_g_performance = detail.order_augment.is_g_performance ? true : false //是否计算采购绩效
      detail.order_augment.is_p_performance = detail.order_augment.is_p_performance ? true : false //是否计算配货绩效
      detail.goods_fee_rule = detail.goods_fee_rule ? true : false //0-收商品金额,1-不收商品金额
      detail.service_fee_rule = detail.service_fee_rule ? true : false //0-按默认规则收取,1-按客户等级收取
      // 本单特殊收费豁免使用数字 0/1，详情回显和报价提交保持一致。
      detail.small_order_fee_exempt = Number(detail.small_order_fee_exempt) === 1 ? 1 : 0
      detail.order_bulk = detail.order_bulk == null ? { air_price: '', sea_price: '' } : detail.order_bulk
      // 隐藏 skip_confirm=1 的番 供应商需要报价的番 业务不隐藏
      if (detail.status == 21 && this.userRole != 1) {
        detail.order_detail = detail.order_detail.filter(item => item.skip_confirm != 1)
      }
      // 存入vuex
      this.$store.commit('getDetail', detail)
      // 计算费用
      this.computationalSost();

    },
    //显示番
    getSorting(set_detail_id) {
      const orderDetail = Array.isArray(this.detail.order_detail) ? this.detail.order_detail : []
      const itemData = orderDetail.find(item => String(item.id) === String(set_detail_id))
      return itemData ? itemData.sorting : ''
    },
    // 计算费用
    computationalSost(type, num, checked, index, goods_id) {
      this.total = {
        goodsAmount: 0,
        domesticFreight: 0,
        additionalServiceCharge: 0,
        totalWeight: 0,
        totalVolume: 0,
      };
      // 不能输入负数
      if (type && !['g_remark', 'y_remark', 'y_reply', 'offer_num', 'confirm_num',].includes(type) && type != 'weight' && type != 'bulk_freight') {
        this.detail.order_detail[index][type] = ("" + this.detail.order_detail[index][type]) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
        // 使用正则表达式来判断是否输入了小数
        this.$forceUpdate()
      }
      // 数量只能输入正整数
      if (['offer_num', 'confirm_num', 'bulk_quantity'].includes(type)) {
        this.detail.order_detail[index][type] = ("" + this.detail.order_detail[index][type])
          .replace(/[^0-9]/g, '') // 第二步：把不是数字
        this.$forceUpdate()
      }
      // 单个重量.kg
      if (['weight', 'bulk_freight'].includes(type)) {
        this.detail.order_detail[index][type] = ("" + this.detail.order_detail[index][type]) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,3})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到3位小数
        // 使用正则表达式来判断是否输入了小数
        // this.detail.order_detail[index][type] = this.detail.order_detail[index][type] - 0
        this.$forceUpdate()
      }
      // 同步实际采购价
      if (type == 'confirm_price') {
        this.detail.order_detail[index].confirm_dicker_price = this.detail.order_detail[index][type]
      }
      this.detail.order_detail.forEach((item) => {
        // 批量修改
        if (item.checked && checked) {
          item[type] = num;
          // 同步实际采购价
          if (type == 'confirm_price') {
            item.confirm_dicker_price = this.detail.order_detail[index][type]
          }
        }

        //同类商品修改重量
        if (item.goods_id == goods_id) {
          item.weight = this.detail.order_detail[index][type]
        }
        // 计算总价
        if (this.status == 20) {
          this.total.goodsAmount += item.userTotal - 0;
        } else if (this.status == 22) {
          item.offer_total = (item.offer_num * item.offer_price);
          this.total.goodsAmount += item.offer_total;
          this.total.domesticFreight += item.offer_freight - 0;
          this.total.totalWeight += item.weight * item.offer_num - 0;
        } else if (this.status == 21) {
          item.confirm_total = item.confirm_num * item.confirm_price;
          this.total.goodsAmount += item.confirm_total;
          if (item.confirm_num > 0) {
            this.total.domesticFreight += item.confirm_freight - 0;
          }

          this.total.totalWeight += item.weight * item.confirm_num - 0;
        } else {
          item.confirm_total = item.offer_num_bak * item.offer_price_bak;
          this.total.goodsAmount += item.offer_num_bak * item.offer_price_bak;
          if (item.offer_num_bak > 0) {
            this.total.domesticFreight += item.offer_freight_bak - 0;
          }
          this.total.totalWeight += item.weight * item.offer_num - 0;
        }
        if (item.option != null) {
          item.option.forEach((opti) => {
            // 按照% 收手续费
            if (opti.price_type == 1) {
              if (this.status == 20) {
                this.total.additionalServiceCharge +=
                  NP.strip(item.price * opti.num * (opti.price / 100));
              } else if (this.status == 22) {
                this.total.additionalServiceCharge +=
                  NP.strip(item.offer_price * opti.num * (opti.price / 100));
              } else {
                this.total.additionalServiceCharge +=
                  NP.strip(item.confirm_price * opti.num * (opti.price / 100));
              }
            } else {
              this.total.additionalServiceCharge += opti.num * opti.price;
            }
            this.total.additionalServiceCharge = NP.strip(this.total.additionalServiceCharge)
          });
        }
        this.total.totalVolume += item.length * item.width * item.height;
      });
      this.total.totalVolume = this.total.totalVolume / 10000

    },
    // 单选
    theRadio() {
      this.checkedList = []
      this.$forceUpdate();
      this.checked = this.detail.order_detail.every((item) => item.checked);
      this.detail.order_detail.forEach(item => {
        if (item.checked) {
          this.checkedList.push(item)
        }
      })
      this.$forceUpdate();
    },
    // 全选
    allChecked() {
      this.checkedList = []
      this.detail.order_detail.forEach((item) => {
        item.checked = this.checked;
        if (item.checked) {
          this.checkedList.push(item)
        }
      });
      this.$forceUpdate();
    },
    // 取消全选
    cancelAllChecked() {
      this.checkedList = []
      this.checked = false
      this.detail.order_detail.forEach((item) => {
        item.checked = false

      });
      this.$forceUpdate();
    },
    handleClick() { },
    // 临时保存
    temporaryStorage() {
      if (this.status == 21) {
        this.submitConfirm(1);
      }
    },
    // 业务提出翻译
    submitTranslate(is_temp) {
      let list = this.detail.order_detail;
      for (let i = 0; i < list.length; i++) {
        // if ((list[i].client_remark != "" && list[i].client_remark != null) && list[i].y_remark == "") {
        //   this.$alert("有客户商品备注未翻译，请翻译后提交", "提示", {
        //     confirmButtonText: "确定",
        //     center: true,
        //   });
        //   return;
        // }
      }
      // 翻译单加入made in china
      this.addMadeInChina(this.detail.order_detail)
      let datas = {
        data: JSON.stringify(this.detail),
        is_temp
      };

      this.$api.orderApi.submitTranslate(datas).then((res) => {
        this.$message.success(res.msg);
        if (is_temp == 0) {
          setTimeout(() => {
            window.open("about:blank", "_top").close();
          }, 1000)
        }

      });
    },
    // 采购确认提出
    submitConfirm(type) {
      let data = {
        order_sn: this.detail.order_sn,
        order_detail: [],
      };
      let list = this.detail.order_detail;
      for (let i = 0; i < list.length; i++) {
        data.order_detail.push({
          id: list[i].id,
          confirm_num: list[i].confirm_num,
          confirm_price: list[i].confirm_price,
          confirm_freight: list[i].confirm_freight,
          confirm_dicker_price: list[i].confirm_dicker_price,
          confirm_dicker_freight: list[i].confirm_dicker_freight,
          g_remark: list[i].g_remark.trim(),
          volume: list[i].length + "x" + list[i].width + "x" + list[i].height,
          weight: list[i].weight * 1000,
          // 大货报价 定制
          bulk_price: list[i].bulk_price,
          // 大货运费 定制
          bulk_freight: list[i].bulk_freight,
          // 大货数量 定制
          bulk_quantity: list[i].bulk_quantity,
          // 大货数量 定制
          bulk_option: list[i].bulk_option,
        });
      }
      let datas = {
        is_temp: type,
        data: JSON.stringify(data),
      };
      this.$api.orderApi.submitConfirm(datas).then((res) => {
        this.$message.success(res.msg);
        if (type != 1) {
          this.orderDetails();
        }
        this.checked = false;
      });
    },
    // 报价临时保存
    makeAnOfferTemporaryStorage() {
      //转寄订单-标记订单手否收商品金额及手续费收取规则
      if (this.detail.type == 2) {
        let updateOrderPayRule = {
          order_sn: this.order_sn,
          goods_fee_rule: this.detail.goods_fee_rule ? 1 : 0,
          service_fee_rule: this.detail.service_fee_rule ? 1 : 0,
        }
        this.$api.orderApi
          .updateOrderPayRule(updateOrderPayRule)
      }
      let list = JSON.parse(JSON.stringify(this.detail.order_detail));
      let str = ''
      for (let i = 0; i < list.length; i++) {
        // 报价数量0 option清0
        if (list[i].offer_num == 0) {
          if (list[i].option != null) {
            list[i].option.forEach(item => {
              item.num = 0
            })
          }
        }
        if (list[i].y_reply == '' && list[i].g_remark != '') {
          str += list[i].sorting + ','
        }
        list[i].confirm_price = list[i].offer_price;
        list[i].confirm_freight = list[i].offer_freight;
        list[i].confirm_num = list[i].offer_num;
        list[i].volume = list[i].length + "x" + list[i].width + "x" + list[i].height
        list[i].weight = list[i].weight * 1000
      }
      let datas = {
        order_sn: this.detail.order_sn,
        other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
        other_price_remark: this.detail.other_price_remark,
        y_reply: this.detail.y_reply,
        y_remark: this.detail.y_remark,
        predict_logistics_price: this.detail.predict_logistics_price,
        order_detail: this.priceOption(list),
        order_part_pay: this.detail.part_pay_status,
        small_order_fee_exempt: this.detail.small_order_fee_exempt,
      };
      this.$api.orderApi
        .submitOffer({ data: JSON.stringify(datas), is_temp: 1, })
        .then((res) => {
          this.$message.success(res.msg);

        });
    },
    //业务报价
    async makeAnOffer() {
      if (this.detail.order_extend.is_supplier_order) {
        // 刷新供应商报价时保留本次尚未提交的豁免选择。
        const smallOrderFeeExempt = this.detail.small_order_fee_exempt
        await this.orderDetails()
        this.detail.small_order_fee_exempt = smallOrderFeeExempt
        // 延迟0.5秒再执行
        await new Promise(resolve => setTimeout(resolve, 500))
        if (!this.detail.supplier_quote_status)
          return this.$alert('当前订单标有供应商商品未报价，请等待供应商报价。', '提示', {
            confirmButtonText: '确定',
            center: true,
            callback: action => {
            }
          });
        this.$forceUpdate()
      }
      //转寄订单-标记订单手否收商品金额及手续费收取规则
      if (this.detail.type == 2) {
        let updateOrderPayRule = {
          order_sn: this.order_sn,
          goods_fee_rule: this.detail.goods_fee_rule ? 1 : 0,
          // service_fee_rule: this.detail.service_fee_rule ? 1 : 0,
        }
        this.$api.orderApi
          .updateOrderPayRule(updateOrderPayRule)
      }
      let list = JSON.parse(JSON.stringify(this.detail.order_detail));
      let str = ''
      for (let i = 0; i < list.length; i++) {
        // 报价数量0 option清0
        if (list[i].offer_num == 0) {
          if (list[i].option != null) {
            list[i].option.forEach(item => {
              item.num = 0
            })
          }
        }

        if (list[i].y_reply == '' && list[i].g_remark != '') {
          str += list[i].sorting + ','
        }
        list[i].confirm_price = list[i].offer_price;
        list[i].confirm_freight = list[i].offer_freight;
        list[i].confirm_num = list[i].offer_num;
        list[i].volume = list[i].length + "x" + list[i].width + "x" + list[i].height
        list[i].weight = list[i].weight * 1000
      }
      // 分批付款
      if (this.detail.part_pay_status && this.detail.order_part_pay == false) {
        return this.$alert('当前订单标识为分配付款，请确认付款方式在报价。', '提示', {
          confirmButtonText: '确定',
          center: true,
          callback: action => {
          }
        });
      }

      // console.log(list);
      if (str) {
        this.$confirm(str + '番未翻译采购备注， 是否继续报价?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(() => {
          this.submitOffer(list)
        }).catch(() => {
        });
      } else {
        this.submitOffer(list)
      }
    },
    // 报价
    submitOffer(list) {
      let datas = {
        order_sn: this.detail.order_sn,
        other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
        other_price_remark: this.detail.other_price_remark,
        y_reply: this.detail.y_reply,
        y_remark: this.detail.y_remark,
        predict_logistics_price: this.detail.predict_logistics_price,
        order_detail: this.priceOption(list),

        order_part_pay: this.detail.part_pay_status,
        small_order_fee_exempt: this.detail.small_order_fee_exempt,
      };
      // console.log(datas, list);


      // let option = []
      // this.priceOption(list).forEach(item => {
      //   option.push(item.option)
      // })
      // console.log(datas, option);
      // return
      //  供应商报价的 刷新数据
      this.$api.orderApi
        .submitOffer({ data: JSON.stringify(datas) })
        .then((res) => {
          this.$message.success(res.msg);
          this.checked = false;
          setTimeout(() => {
            window.open("about:blank", "_top").close();
          }, 1000)
        });
    },
    // 退回待报价
    backToWaitOffer() {
      let datas = {
        order_sn_set: [this.detail.order_sn],
      };

      this.$confirm(
        this.$t("message.isReturnToBeQuoted"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.backToWaitOffer(datas).then((res) => {
            this.$message.success(res.msg);
            this.orderDetails();
          });
        })
        .catch(() => { });
    },
    // -回退到待翻译
    backToWaitTranslate() {
      let datas = {
        order_sn_set: [this.detail.order_sn],
      };
      this.$confirm(
        this.$t("message.isBackToWaitTranslate"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.backToWaitTranslate(datas).then((res) => {
            this.$message.success(res.msg);
            this.orderDetails();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 退给采购
    backToWaitConfirm() {
      this.$confirm(
        this.$t("message.whetherToReturnThisOrderToPurchaseForReconfirmation"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let list = JSON.parse(JSON.stringify(this.detail.order_detail));
          for (let i = 0; i < list.length; i++) {
            // 报价在库数 为0， option清空
            if (list[i].offer_num == 0) {
              list[i].option = []
            }
            list[i].confirm_price = list[i].offer_price;
            list[i].confirm_freight = list[i].offer_freight;
            list[i].confirm_num = list[i].offer_num;
            list[i].volume = list[i].length + "x" + list[i].width + "x" + list[i].height
            list[i].weight = list[i].weight * 1000
          }
          let datas = {
            order_sn: this.detail.order_sn,
            other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
            other_price_remark: this.detail.other_price_remark,
            y_reply: this.detail.y_reply,
            y_remark: this.detail.y_remark,
            predict_logistics_price: this.detail.predict_logistics_price,
            order_detail: list,
          };
          this.$api.orderApi.backToWaitConfirm({ data: JSON.stringify(datas) }).then((res) => {
            this.$message.success(res.msg);
            this.orderDetails();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 上传成功
    handleAvatarSuccess(res) {
      this.detail.order_detail[this.i].pic = res.data;
      this.loading = false;
    },
    // 上传前
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";

      this.loading = true;
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false;
      }
      return isJPG || isPNG || isSVG;
    },
    //业务修改属性
    attributeEdit(item, i) {
      this.i = i;
      this.itemDetail = item;
      this.attributeDialogVisible = true;
    },
    // option修改
    optionEdit(item, i) {
      this.i = i;
      this.itemDetail = item;
      this.optionsDialogVisible = true;
    },
    // 编辑替换链接
    editSetReplaceGoods(item) {
      this.$refs.replaceGoodsOfferEdit.form = {
        link: '',
        order_detail_id: item.id,
        from_platform: '',
        goods_id: '',
        pic: '',
        shop_id: '',
        shop_name: '',
        detail: [],
        sku_id: '',
        spec_id: '',
        detail_y: [],
        sku_id_y: '',
        spec_id_y: '',
      }
      this.$refs.replaceGoodsOfferEdit.dialogVisible = true
    },
    // 替换商品信息
    replaceGoodsInfo(replace_goods_info) {
      this.$refs.replaceLink.replace_goods_info = replace_goods_info
      this.$refs.replaceLink.dialogVisible = true
    },
    // 接收修改属性
    receiveAttributeEdit(data, pic, arr, spec_id) {
      this.detail.order_detail[this.i].detail_y = data;
      this.detail.order_detail[this.i].spec_id = spec_id
      this.detail.order_detail[this.i].sku_id = spec_id
      this.detail.order_detail[this.i].spec_id_y = spec_id
      this.detail.order_detail[this.i].sku_id_y = spec_id

      console.log(this.detail.order_detail[this.i]);
      if (pic) {
        this.detail.order_detail[this.i].pic = pic;
      }

      this.attributeDialogVisible = false;
    },
    // 同店铺商品
    sameShop() {
      let list = [];
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      list.forEach((item) => {
        this.detail.order_detail.forEach((items) => {
          if (item.shop_id == items.shop_id) {
            items.checked = true;
          }
        });
      });
      this.$forceUpdate();
    },
    // 同ID商品
    sameID() {
      let list = [];
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      list.forEach((item) => {
        this.detail.order_detail.forEach((items) => {
          if (item.goods_id == items.goods_id) {
            items.checked = true;
          }
        });
      });
      this.$forceUpdate();
    },
    //直接付款
    async adminOrderPay() {
      //转寄订单-标记订单手否收商品金额及手续费收取规则
      if (this.detail.type == 2) {
        let updateOrderPayRule = {
          order_sn: this.order_sn,
          goods_fee_rule: this.detail.goods_fee_rule ? 1 : 0,
          service_fee_rule: this.detail.service_fee_rule ? 1 : 0,
        }
        this.$api.orderApi
          .updateOrderPayRule(updateOrderPayRule)
      }

      let amount = 0 // 付款的金额
      if (this.detail.part_pay_status) {
        // 分批付款
        if (this.detail.order_part_pay == false) {
          return this.$alert('当前订单标识为分配付款，请确认付款方式在报价。', '提示', {
            confirmButtonText: '确定',
            center: true,
            callback: action => {

            }
          });
        }
        amount = this.order_part_pay()
      } else {
        // 全款
        amount = (this.domesticSubtotal * this.rate).toFixed(0)
      }
      //  供应商报价的 刷新数据
      if (this.detail.order_extend.is_supplier_order) {
        // 直接付款也会先提交报价，刷新时保留本单豁免选择。
        const smallOrderFeeExempt = this.detail.small_order_fee_exempt
        await this.orderDetails()
        this.detail.small_order_fee_exempt = smallOrderFeeExempt
        // 延迟0.5秒再执行
        await new Promise(resolve => setTimeout(resolve, 500))
        this.$forceUpdate()
      }


      if (this.status == 22) {
        let list = JSON.parse(JSON.stringify(this.detail.order_detail));
        let str = ''
        for (let i = 0; i < list.length; i++) {
          if (list[i].offer_num == 0) {
            if (list[i].option != null) {
              list[i].option.forEach(item => {
                item.num = 0
              })
            }
          }
          if (!list[i].offer_price) {
            this.$alert("报价单价不能为0或者为空", "提示", {
              confirmButtonText: "确定",
              center: true,
            });
            return;
          }
          if (list[i].y_reply == '' && list[i].g_remark != '') {
            str += list[i].sorting + ','
          }

          // 报价在库数 为0， option清空
          // if (list[i].offer_num == 0) {
          //   list[i].option = []
          // }
          list[i].confirm_price = list[i].offer_price;
          list[i].confirm_freight = list[i].offer_freight;
          list[i].confirm_num = list[i].offer_num;
          list[i].volume = list[i].length + "x" + list[i].width + "x" + list[i].height
          list[i].weight = list[i].weight * 1000
        }


        if (str) {
          let datas = {
            order_sn: this.detail.order_sn,
            other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
            other_price_remark: this.detail.other_price_remark,
            y_reply: this.detail.y_reply,
            y_remark: this.detail.y_remark,
            predict_logistics_price: this.detail.predict_logistics_price,
            order_detail: this.priceOption(list),
            order_part_pay: this.detail.part_pay_status,
            small_order_fee_exempt: this.detail.small_order_fee_exempt,
          };

          this.$alert(`<p>客户可用余额:<b style="color:red"> ${this.detail.user.balance}</b>付款后余额:<b style="color:red"> ${this.detail.user.balance - amount} </b> </p>
      <p> 是否直接残金付款?</p>`, '直接付款', {
            confirmButtonText: '确定',
            center: true,
            dangerouslyUseHTMLString: true,
            callback: action => {
              if (action == 'confirm') {
                this.$api.orderApi
                  .submitOffer({ data: JSON.stringify(datas) })
                  .then((res) => {
                    let data = {
                      order_sn: this.order_sn
                    }
                    this.loading = true;
                    setTimeout(() => {
                      this.loading = false
                      this.$api.clienteleApi.orderPay(data).then((res) => {
                        this.$message.success(res.msg);
                        this.$api.orderApi.updateStatus({ order_sn: this.detail.order_sn, }).then(res => {
                          setTimeout(() => {
                            window.open("about:blank", "_top").close();
                          }, 1000)
                        })
                      })
                    }, 3000)

                  });
              }
            }
          });

        } else {
          let datas = {
            order_sn: this.detail.order_sn,
            other_price: this.detail.other_price > 0 ? this.detail.other_price : 0,
            other_price_remark: this.detail.other_price_remark,
            y_reply: this.detail.y_reply,
            y_remark: this.detail.y_remark,
            predict_logistics_price: this.detail.predict_logistics_price,
            order_detail: this.priceOption(list),
            order_part_pay: this.detail.part_pay_status,
            small_order_fee_exempt: this.detail.small_order_fee_exempt,
          };
          this.$alert(`<p>客户可用余额:<b style="color:red"> ${this.detail.user.balance}</b>付款后余额:<b style="color:red"> ${this.detail.user.balance - amount}</b></p>
      <p> 是否直接残金付款?</p>`, '直接付款', {
            confirmButtonText: '确定',
            center: true,
            dangerouslyUseHTMLString: true,
            callback: action => {
              if (action == 'confirm') {
                this.$api.orderApi
                  .submitOffer({ data: JSON.stringify(datas) })
                  .then((res) => {
                    let data = {
                      order_sn: this.order_sn
                    }
                    this.loading = true;
                    setTimeout(() => {
                      this.loading = false
                      this.$api.clienteleApi.orderPay(data).then((res) => {
                        this.$message.success(res.msg);
                        this.$api.orderApi.updateStatus({ order_sn: this.detail.order_sn, }).then(res => {
                          setTimeout(() => {
                            window.open("about:blank", "_top").close();
                          }, 1000)
                        })
                      })
                    }, 3000)

                  });
              }
            }
          });
        }
      } else {
        this.$alert(`<p>客户可用余额:<b style="color:red"> ${this.detail.user.balance}</b>付款后余额:<b style="color:red"> ${this.detail.user.balance - amount}</b></p>
      <p> 是否直接残金付款?</p>`, '直接付款', {
          confirmButtonText: '确定',
          center: true,
          dangerouslyUseHTMLString: true,
          callback: action => {
            if (action == 'confirm') {
              let data = {
                order_sn: this.order_sn
              }
              this.$api.clienteleApi.orderPay(data).then((res) => {
                this.$message.success(res.msg);
                this.$api.orderApi.updateStatus({ order_sn: this.detail.order_sn, }).then(res => {
                  setTimeout(() => {
                    window.open("about:blank", "_top").close();
                  }, 1000)
                })
              })
            }
          }
        });
      }
    },
    //分批付款 首付金额查询
    order_part_pay() {
      let amount = 0 // 付款的金额
      let firstKin = this.detail.order_part_pay[0]
      firstKin.total = (firstKin.other_amount - 0) + (firstKin.option_amount - 0) + (firstKin.service_amount - 0) + (firstKin.freight_amount - 0) + (firstKin.goods_amount - 0)
      amount = (firstKin.total * this.rate).toFixed(0)
      return amount
    },
    //排序
    homogeneousGrouping(flag) {
      if (flag) {
        this.$confirm(
          '按分类分组后，当前页面编辑的信息如果没有进行保存将会重置，请保存好再排序，是否确认进行分组排序',
          this.$t("message.hint"),
          {
            confirmButtonText: this.$t("message.ok"), //确定
            cancelButtonText: this.$t("message.cancel"), //取消
            type: "warning",
            center: true,
          }
        )
          .then(() => {
            this.detail.order_detail = []
            this.order_detail.forEach(item => {
              if (item.from_platform == '1688') {
                this.detail.order_detail.push(item)
              }
            })
            this.order_detail.forEach(item => {
              if (item.from_platform == 'taobao') {
                this.detail.order_detail.push(item)
              }
            })
            this.order_detail.forEach(item => {
              if (item.from_platform == 'tmall') {
                this.detail.order_detail.push(item)
              }
            })
            this.order_detail.forEach(item => {
              if (item.from_platform == 'wangyi') {
                this.detail.order_detail.push(item)
              }

            })
            console.log(this.order_detail);

            this.isHomogeneousGrouping = false
            this.$forceUpdate();
          })
          .catch(() => { });
      } else {
        this.isHomogeneousGrouping = true
        this.detail.order_detail = JSON.parse(JSON.stringify(this.order_detail))
      }

    },
    // 删除商品
    deleteFromOrder() {
      let ids = []
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          ids.push(item.id)
        }
      });
      if (ids == false)
        return this.$message.error(
          this.$t("message.selectableOperationalList")
        );
      this.$confirm(
        this.$t("message.whetherToDeleteTheSelectedOrder"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          let datas = {
            ids: ids
          }
          this.$api.orderApi.deleteFromOrder(datas).then((res) => {
            this.$message.success(res.msg);
            this.orderDetails();
            this.checked = false
          });
        })
        .catch(() => { });
    },
    //复制选择商品信息
    copyText() {
      let list = []
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          list.push(item);
        }
      });
      if (list.length === 0) {
        this.$message.error(this.$t("message.pleaseSelectAtLeastOne")); //请至少选中一项
        return;
      }
      let copyUrl = "";
      list.forEach((item) => {
        let size = "";
        if (item.detail.length > 0) {
          if (this.status <= 20) {
            item.detail.forEach((items) => {
              size += items.key + ":" + items.value + "  ";
            });
          } else {
            item.detail_y.forEach((items) => {
              size += items.key + ":" + items.value + "  ";
            });
          }
        }
        if (this.userRole == 1) { // 业务复制商品信息
          copyUrl += `${this.order_sn}\n${item.sorting}番   ${item.link}\n`;
        } else {
          copyUrl += `${size} 数量: ${item.num}\n`;
        }
      });
      //每一行的数据
      this.copy(copyUrl)
    },
    //订单拆单
    splitOrder() {
      let datas = {
        orderDetailIds: []
      }
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          datas.orderDetailIds.push(item.id)
        }
      });
      if (datas.orderDetailIds == false) return this.$message.error(this.$t('message.selectableOperational'))

      this.$confirm('此操作将选中的商品拆分成一个新订单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.$api.orderApi.splitOrder(datas).then(res => {
          this.orderDetails();
          this.copy(res.data)
          this.$alert("新订单的单号:" + res.data, "提示", {
            confirmButtonText: "确定",
            center: true,
          });
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        });
      });
    },
    //商品监控
    commodityMonitoringEntry() {
      this.$refs.monitorProductSettings.dialogVisible = true
    },
    //标签编辑
    tagEdit(item, index) {
      this.i = index
      if (item.order_detail_tag != false) {
        this.tagData = JSON.parse(JSON.stringify(item.order_detail_tag[0]))
      } else {
        this.tagData = {
          code_type: 'CODE128',
          goods_no: '',
          no: '',
          type: 'FBA',
        }
      }
      if (!this.tagData.num) {
        this.tagData.num = item.num
      }
      this.$refs.TagEdit.dialogVisible = true
    },
    //撤回翻译
    isYEditing(type) {
      let datas = {
        order_sn: this.order_sn,
        is_y_editing: type
      }
      this.$api.orderApi.isYEditing(datas).then(res => {
        this.$message.success(res.msg)
        if (type == 0) {
          this.orderDetails()
        }
      })
    },
    //详细检品，系统自动根据报价单价修改option
    //単価１５元以下の商品１点1.5元
    //単価３０元以下の商品１点２元
    priceOption(list) {
      list.forEach(item => {
        if (item.option != null) {
          item.option.forEach((opti, i) => {
            // 详细检品低于30重新计算
            if (opti.name == '详细检品' || opti.name == '详细检品(单价)') {
              if (item.offer_price <= 30) {
                item.option.push(
                  {
                    auto_calculate: 1,
                    checked: true,
                    edit: false,
                    is_overstep: 0,
                    name: "详细检品(单价)",
                    name_translate: "詳細検品",
                    price_type: 0,
                    price: item.offer_price > 15 ? 2 : 1.5,
                    num: opti.num,
                    unit: '元'
                  }
                )
                item.option.splice(i, 1)

              }
            }
            // 数组去重
            var hash = {};
            item.option = item.option.reduce(function (items, next) {
              hash[next.name]
                ? ""
                : (hash[next.name] = true && items.push(next));
              return items;
            }, []);
          })
        }
      })
      list.forEach(item => {

        if (item.option != null) {
          item.option.forEach((opti, i) => {
            // 拍照张数计算
            if (opti.name == '拍照') {
              let price = 0
              if (opti.num == 1) {
                price = 12
              } else if (opti.num >= 2 && opti.num <= 5) {
                price = 40
              } else if (opti.num >= 6 && opti.num <= 8) {
                price = 60
              } else if (opti.num > 8) {
                let num = opti.num - 8
                price = 60
                price += num * 7
              }

              item.option.push(
                {
                  auto_calculate: 0,
                  checked: true,
                  edit: false,
                  is_overstep: 0,
                  name: `摄影(${opti.num}张)`,
                  name_translate: `写真(${opti.num}枚)`,
                  price_type: 0,
                  price,
                  num: 1,
                  unit: '元'
                }
              )

              item.option.splice(i, 1)
            }
            // 数组去重
            var hash = {};
            item.option = item.option.reduce(function (items, next) {
              hash[next.name]
                ? ""
                : (hash[next.name] = true && items.push(next));
              return items;
            }, []);
          })
        }

      })
      return list
    },
    //同步运费
    synchronousFreight(freight, index) {
      this.detail.order_detail[index].confirm_freight = ("" + this.detail.order_detail[index].confirm_freight) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      this.detail.order_detail[index].confirm_dicker_freight = this.detail.order_detail[index].confirm_freight

      this.computationalSost();
      this.$forceUpdate();
    },
    //新增商品
    placeANewOrder() {
      this.$refs.addGoods.dialogVisible = true
      this.$refs.addGoods.setData(
        this.detail.user.id,
        this.detail.user.realname,
      )
    },
    //生成1688订单价格预览
    orderCreatePreview() {
      let datas = {
        order_sn: this.order_sn,
        list: [],
      }
      this.detail.order_detail.forEach(item => {
        if (item.from_platform == '1688') {
          datas.list.push({
            sku_id: item.sku_id_y,
            spec_id: item.spec_id_y,
          })
        }
      })
      this.$api.orderApi.orderCreatePreview(datas).then(res => {
        this.detail.order_detail.forEach(item => {
          if (item.from_platform == '1688') { // 1688才生效
            res.data.forEach(shop => {
              shop.goodsList.forEach(goods => {
                if (goods.specId == item.spec_id_y) { //属性规格相同
                  item.confirm_dicker_price = goods.finalUnitPrice
                } else if (goods.offerId == item.goods_id) { //商品相同
                  item.confirm_dicker_price = goods.finalUnitPrice
                }
              })
            })
          }
        })
      })
    },
    // 双路检测中只要有一路明确为高风险，就显示侵权风险入口。
    isShowTortRisk(tortDetect) {
      return !!tortDetect && (
        tortDetect.vision_risk_level == 'high' ||
        tortDetect.fingerprint_risk_level == 'high'
      )
    },
    // 取双路中更高的风险等级：high > medium
    getTortRiskLevel(tortDetect) {
      if (!tortDetect) return ''
      const levels = [tortDetect.vision_risk_level, tortDetect.fingerprint_risk_level]
      if (levels.indexOf('high') != -1) return 'high'
      if (levels.indexOf('medium') != -1) return 'medium'
      return ''
    },
    // 高风险红色，中风险橙色
    getTortRiskType(tortDetect) {
      return this.getTortRiskLevel(tortDetect) == 'high' ? 'danger' : 'warning'
    },
    // 打开当前商品的侵权识别详情
    openTortDetect(item) {
      this.$refs.tortDetectDetail.openDialog(item)
    },
    // 设置备注
    setRemark(item) {
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.$refs.setRemarks.dialogVisible = true
    },
    // 历史备注
    historyRemarkLisy(item) {
      this.itemDetail = JSON.parse(JSON.stringify(item))
      this.$refs.historyRemark.dialogVisible = true
    },
    // 品名材质
    orderMaterialPreview() {
      this.orderMaterial = 0;
      this.$api.orderApi
        .orderMaterialPreview({
          order_sn: this.order_sn,
        })
        .then((res) => {
          res.data.order_detail.forEach((item) => {
            if (item.order_detail_material != null) {
              if (item.order_detail_material.goods_name_cn) {
                this.orderMaterial++;
              }

            }
          });
        });
    },
    //订单-修改管理番号
    batchUpdateOrderDetailForSn(item) {
      let datas = {
        order_detail_id_set: [item.id],
        for_sn: item.for_sn
      }
      this.$api.orderApi.batchUpdateOrderDetailForSn(datas)
    },
    //订单-尝试补全订单信息
    reCompletion() {
      this.$api.orderApi.reCompletion({ order_sn: this.order_sn }).then(res => {
        this.$message.success(res.msg)
        this.orderDetails();
      })
    },
    //加入商品库
    inventoryBatchSave() {
      let datas = {
        user_id: this.detail.user_id,
        data: []
      }
      this.detail.order_detail.forEach((item) => {
        if (item.checked) {
          item.shop_type = item.from_platform
          item.img_url = item.pic
          datas.data.push({
            shop_type: item.from_platform,
            img_url: item.pic,
            shop_id: item.shop_id,
            goods_id: item.goods_id,
            num: item.num,
            price: item.price,
            sku_id: item.sku_id,
            spec_id: item.spec_id,
            shop_name: item.shop_name,
            goods_title: item.goods_title,
            detail: JSON.stringify(item.detail),
            option: JSON.stringify(item.option),
            note: '',
            for_sn: '',
            detail_edit: '',
            copy_from_id: '',
          });
        }
      });
      if (datas.data == false) return this.$message.error('请选择商品')
      this.$api.clienteleApi.inventoryBatchSave(datas).then(res => {
        this.$message.success(res.msg)

      })

    },
    // 按订单详情 ID 创建商品管理数据，接口为单条提交，勾选多番时依次处理。
    async createProductManagement() {
      const orderDetailIds = [...new Set(this.checkedList
        .map(item => Number(item.id))
        .filter(id => Number.isInteger(id) && id > 0))]
      if (!orderDetailIds.length) {
        return this.$message.error(this.$t("message.selectableOperational"))
      }
      this.creatingProductManagement = true
      try {
        const messages = []
        for (const order_detail_id of orderDetailIds) {
          const res = await this.$api.productManagementApi.createFromOrderDetail({ order_detail_id })
          if (res && (res.success === false || (res.code !== undefined && res.code != 0))) {
            throw new Error(res.msg || this.$t('message.joinProductManagementFailed'))
          }
          const result = res.data || {}
          messages.push(result.message || res.msg || this.$t('message.joinProductManagementSuccess'))
        }
        await this.$alert([...new Set(messages)].join('；'), '提示', {
          confirmButtonText: this.$t('message.confirm'),
          type: 'success',
          showClose: false,
        })
        await this.orderDetails()
      } catch (error) {
        this.$alert(error.message || this.$t('message.joinProductManagementFailed'), '提示', {
          confirmButtonText: this.$t('message.confirm'),
          type: 'error',
        })
      } finally {
        this.creatingProductManagement = false
      }
    },
    //查询商品历史长宽高重
    goodsWeightSizeHistory() {
      let datas = {
        goods_id_set: []
      }
      this.detail.order_detail.forEach(item => {
        datas.goods_id_set.push(item.goods_id)
      })
      this.$api.orderApi.goodsWeightSizeHistory(datas).then(res => {
        res.data.forEach(item => {
          let volume = item.volume.split('x')
          this.detail.order_detail.forEach(items => {
            if (item.goods_id == items.goods_id) {
              items.length = volume[0]
              items.width = volume[1]
              items.height = volume[2]
              items.weight = item.weight
            }
          })
        })
        this.computationalSost();
      })
      console.log();
    },
    //再来一单：复制商品时一并带上辅料标识和辅料绑定列表
    raiseAnotherOrder() {
      if (this.checkedList == false) return this.$message.error(this.$t('message.selectableOperationalList'))
      const sourceList = this.checkedList
      this.$api.orderApi.copyOrder({
        user_id: this.user_id,
        order_sn: this.order_sn,
        order_detail_id: sourceList.map(item => item.id)
      }).then(res => {
        const orderList = res.data.order_data.reduce((goods, order) => goods.concat(order.goods), [])
        orderList.forEach((goods, index) => {
          const source = sourceList[index]
          if (!source) return
          const isMaterial = Number(source.is_material) === 1 || source.is_material === true
          const materialId = isMaterial
            ? (source.material_id || (source.material && source.material.id) || '')
            : ''
          goods.is_material = isMaterial
          goods.material_id = materialId
          goods.material = isMaterial ? (source.material || null) : null
          goods.material_detail = isMaterial ? (source.material_detail || source.material || null) : null
          goods.material_bind = Array.isArray(source.material_bind)
            ? JSON.parse(JSON.stringify(source.material_bind))
            : []
        })
        let routeUrl = this.$router.resolve({
          path: "/orderPreview?userID=" + this.user_id + "&type=raiseAnotherOrder",
        });
        let data = {
          orderList,
          y_reply: this.detail.y_reply,
          y_remark: this.detail.y_remark,
        }
        window.open(routeUrl.href, JSON.stringify(data));
      })
    },
    //翻译单加入made in china
    addMadeInChina(list) {
      list.forEach(item => {
        // 定额会员及SVIP上的订单会员类型，提出报价时，所有番附加服务默认勾选上：made in china 贴付  
        if ((this.detail.attribute_name == '付费会员' || this.detail.attribute_name == 'SVIP') && this.detail.user.user_extend.allow_made_in) {
          if (item.option == null) {
            item.option = []
          }
          let FBAFlag = item.option.some(opti => opti.name == 'FBA贴标')
          let madeFlag = item.option.some(opti => opti.name == 'made in China')
          // if (i !== -1) {
          //   item.option.splice(i, 1)
          // }
          if (!FBAFlag && !madeFlag) {
            item.option.push(
              {
                auto_calculate: 0,
                checked: true,
                edit: false,
                is_overstep: 0,
                name: `made in China`,
                name_translate: `made in China`,
                price_type: 0,
                price: 0,
                num: item.num,
                unit: '元'
              }
            )
          }

          // 数组去重
          var hash = {};
          item.option = item.option.reduce(function (items, next) {
            hash[next.name]
              ? ""
              : (hash[next.name] = true && items.push(next));
            return items;
          }, []);
        }
      })
    },
    //原价计算option
    bulkOptionEdit(item, index) {
      this.itemDetail = JSON.parse(JSON.stringify(item));
      this.i = index;
      this.$refs.bulk_option.dialogVisible = true
    },
    // 预设任务
    createPresetTask() {
      let ids = []
      this.checkedList.forEach(item => {
        ids.push(item.id)
      })
      if (ids == false) return this.$message.error('请选择需要抽查的番后再预设任务。')
      this.$refs.presetTask.typeList = [1, 2,]
      this.$refs.presetTask.dialogVisible = true
      this.$refs.presetTask.ids = ids
    },
    // 创建成功并加入列表
    successPresetTask(data) {
      this.detail.order_detail.forEach(item => {
        if (item.checked) {
          item.preset_spot_list.push(data)
        }
      })
      this.$forceUpdate()
    },
    // 1688图搜
    uploadImagePic(url) {
      let that = this
      var img = new Image();
      img.src = url
      img.crossOrigin = 'Anonymous'; // 如果图片需要跨域访问，可以设置这个属性
      img.onload = function () {
        let width = img.width;
        let height = img.height;
        if (width > height) {
          if (width > 200) {
            height *= 200 / width;
            width = 200;
          }
        } else {
          if (height > 200) {
            width *= 200 / height;
            height = 200;
          }
        }
        var canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        var base64 = canvas.toDataURL('image/png', 0.5); // 可以改为image/jpeg，image/webp等其他格式
        let index = base64.indexOf('base64,');
        let base64String = base64.substr(index + 7, base64.length);
        let datas = {
          XYT: '/1/com.alibaba.fenxiao.crossborder/product.image.upload',
          uploadImageParam: JSON.stringify({
            imageBase64: base64String
          })
        }
        that.$api.uploadImagePic(datas).then(res => {
          window.open(`https://pages-fast.1688.com/wow/cbu/srch_rec/image_search/youyuan/index.html?tab=imageSearch&imageId=${res.data.result}&imageIdList=${res.data.result}`)
        })
      };
    },
    // 获取服务单-设置是否前置
    preServiceGet() {
      if (this.checkedList.length == 0) return this.$message.error('请选择番后再设置服务前置。')
      this.$refs.preServiceSet.selectedOrder = this.checkedList
      this.$refs.preServiceSet.preServiceGet()
    }
  },
};
</script>

<style lang='scss' scoped>
// @import url('./index.scss');

/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}

/deep/.is-disabled {
  .el-textarea__inner {
    background-color: #fff !important;
    color: #606266;
  }
}

.client_remark {
  /deep/ .el-textarea__inner {
    background-color: #fef0f0 !important;
  }
}

.table {

  /deep/.el-textarea__inner {
    padding: 5px;
    min-height: 63px !important;
    height: 100% !important;
  }

  /deep/.el-input__inner {
    padding: 0;
    text-align: center;
  }

  .y_reply {
    /deep/.el-textarea__inner {
      background-color: rgba(193, 248, 218, 0.8);

    }
  }
}

.detail {
  min-width: 1910px;
}

.orderDetail {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;
  margin: 24px;

  .tabs {
    display: flex;
    align-items: flex-start;
    margin-bottom: 20px;

    >.el-tabs {
      flex: 1;
      min-width: 0;
    }

    .tabsActions {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      margin-left: 16px;
      padding-top: 5px;

      .el-button+.el-button {
        margin-left: 12px;
      }
    }
  }

  .table {
    font-size: 12px;

    ol {
      position: sticky;
      top: 0;
      left: 0;
      z-index: 9;
      display: flex;
      height: 40px;
      background: #edeff4;
      border-radius: 4px 4px 0px 0px;
      justify-content: center;
      align-items: center;

      li {
        height: 40px;
        text-align: center;
        align-items: center !important;
      }
    }

    li {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 5px;

      &:nth-last-child(1) {
        margin-right: 0;
      }

      .isCustomMade {
        padding-top: 5px;

        /deep/.el-input__inner {
          background-color: rgba(255, 255, 0, 1);

        }
      }
    }

    .flex05 {
      flex: 0.5;
      position: relative;

      .isZhu {
        position: absolute;
        bottom: 5px;
        left: 5px;
        width: 100px;
        color: #B4272D;
        font-weight: 600;
        cursor: pointer;
        z-index: 99;
      }

      .isTong {
        color: #85ce61;
      }
    }

    .noCell {
      flex-direction: column;
      gap: 4px;

      .materialMarkTip {
        position: absolute;
        top: -8px;
        left: 0;
        z-index: 2;
      }

      .materialToggle {
        position: absolute;
        right: -20px;
        bottom: -8px;
        min-width: 56px;
        height: 24px;
        padding: 0 6px;
        border: 0;
        border-radius: 4px;
        background-color: #f5f7fa;
        color: #606266;

        &:hover,
        &:focus {
          background-color: #ecf5ff;
          color: #409eff;
        }

        i {
          margin-left: 2px;
          font-size: 12px;
        }
      }
    }

    // 固定左右区域宽度，辅料卡片超出时只在左侧横向滚动。
    .materialRequirements {
      display: flex;
      gap: 24px;
      min-width: 0;
      padding: 16px 20px;
      border-bottom: 1px solid #edeff4;
      background-color: #fff;
      box-sizing: border-box;
    }

    .materialRequirementsList,
    .materialRequirementsRemarks {
      flex: 1 1 0;
      min-width: 0;
    }

    .materialRequirementsList {
      /deep/ .material-info-panel {
        padding: 0;
        border: 0;
      }

      /deep/ .material-list {
        display: flex;
        overflow-x: auto;
        padding: 10px 10px 8px 0;
      }

      /deep/ .material-card {
        flex: 0 0 288px;
      }

      /deep/ .empty {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 136px;
        padding: 0;
      }
    }

    .materialRequirementsRemarks {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 16px;

      &.singleRequirement {
        grid-template-columns: minmax(0, 1fr);
      }
    }

    .requirementItem {
      display: flex;
      flex-direction: column;
      min-width: 0;

      label {
        display: block;
        margin-bottom: 10px;
        color: #333;
        font-size: 14px;
        font-weight: bold;
      }

      /deep/ .el-textarea {
        display: flex;
        flex: 1;
      }

      /deep/ .el-textarea__inner {
        flex: 1;
        min-height: 96px !important;
        height: auto !important;
      }
    }

    .flex2 {
      flex: 2;
    }

    .flex15 {
      flex: 1.5;
    }

    .important {
      background-color: #e0e7f7;
      max-height: 100px;
      overflow-y: hidden;
    }

    .shop {
      flex: 0 0 100px;
    }

    ul {
      display: flex;
      padding: 10px 0;
      border-bottom: 1px solid #edeff4;
      transition: all 0.3s;
      height: 100px;

      .sorting {
        position: relative;

        .goods-inquiry-tag {
          display: block;
          margin-top: 4px;
          cursor: pointer;
        }

        .claim {
          position: absolute;
          left: -10px;
          top: -40px;

          i {
            color: #B4272D;
            font-size: 20px;
          }
        }

        .contraband {
          position: absolute;
          top: -30px;
          right: -20px;

          img {
            width: 30px;
          }
        }
      }

      &:hover {
        background-color: #fff;
      }

      .template {
        text-align: center;
        width: 100%;


        p {
          margin-bottom: 5px;
        }

        .shopName {
          width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

        }

        .goodsId {
          color: #409eff;
          cursor: pointer;
        }

      }



      .attribute {
        text-align: left;
        width: 100%;
        padding: 3%;
        height: 100%;
        overflow-y: hidden;

        .row {
          width: 100%;
          margin-bottom: 5px;
        }
      }

      .services {
        text-align: left;
      }

      .text {
        display: block;
        height: 100%;
        overflow: auto;
        padding: 5px;

      }

      .el-textarea {
        height: 100%;
      }

      label {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .tort-detect-tag {
        margin-bottom: 5px;
        cursor: pointer;
      }

      .pic {
        position: relative;
        display: flex;
      }

      .edit {
        width: 20px;
        height: 20px;
        margin-left: 5px;

        i {
          font-size: 20px;
          color: #2c96e7;
          cursor: pointer;
        }
      }
    }
  }

  .operate {
    // 独立选择按钮增加后可能换行，建立独立格式化上下文以容纳右侧浮动按钮。
    display: flow-root;
    position: sticky;
    bottom: 0;
    left: 0;
    z-index: 9;
    padding: 12px;
    background: #edeff4;
    border-radius: 0px 0px 8px 8px;

    .el-button {
      margin-left: 5px;
      padding: 8px 12px;
    }

  }
}

.hint {
  background-color: #B4272D;
  color: #FFF;
}

.editItem {
  background-color: #FFF189 !important;
}

.addItem {
  background-color: #85ce61 !important;
}

.orderEdit {
  background-color: #B4272D;
  color: #fff;
}
</style>
